import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const messages = {
    en: {
        gold: 'Gold',
        gems: "Gems",
        locker: 'Locker',
        buy: 'Buy',
        buybuttontxt: 'Buy ₹ {mintingcost}',
        sell: 'Sell',
        confirm: 'Confirm',
        cancel: 'Cancel',
        goldlockerbalance: 'Gold Locker Balance',
        askedquestion: 'Frequently Asked Questions',
        recenttransaction: 'Recent Transactions',
        choosegoldseller: 'Choose Gold Seller',
        buyingrams: 'Buy in Grams',
        buyinamount: 'Buy in Amount',
        sellingrams: 'Sell in Grams',
        sellinamount: 'Sell in Amount',
        successfulpayment: 'Successful purchase of gold',
        unsuccessfulpayment: 'Your transaction was unsuccessful',
        selleragent: 'Seller Agent',
        seelocker: 'View Locker',
        paymentreview: 'Payment Review',
        basedongoldprise: 'Based on Gold Price',
        boughtgold: 'Your purchased gold',
        discount: 'Discount',
        paywithdiscount: 'Payment (with discount)',
        processingcharge: 'Processing charge',
        pay: 'You have to pay',
        sellgold: 'Sell Gold',
        buygold: 'Buy Gold',
        registration: 'Registration',
        consumerdetail: 'Consumer Details',
        username: 'User Name',
        email: 'Email',
        phone_no: 'Mobile Number',
        address: 'Address',
        street: 'Street',
        pincode: 'PIN Code',
        city: 'City',
        state: 'State',
        aaddhar_no: 'Aadhar Number',
        pan_number: 'PAN Number',
        account_name: 'Bank Holder Name',
        bankaccount: 'Bank Account',
        re_bank_aacount: 'Re Bank Account',
        ifsc_code: 'IFSC Code',
        bank: 'Bank',
        submit: 'Submit',
        include_gst: 'Include 3% GST',
        enteramount: 'Enter Amount',
        total_amount: 'Total Amount',
        purity: 'Purity',
        fill_username: 'Please fill in the user name',
        fill_phoneno: 'Please fill in the correct phone number',
        fill_pincode: 'Please fill in the correct pincode',
        fill_city: 'Please fill in the correct city',
        fill_aadhar: 'Please fill in the correct Aadhar No.',
        fill_panno: 'Please fill in the correct PAN No.',
        holder_name: 'Please fill in the correct bank account holder name',
        fill_bankaccount: 'Please fill in the correct bank account',
        fill_ifsccode: 'Please fill in the correct IFSC code',
        fill_upicode: 'Please fill in the correct UPI code',
        termsandcondition: 'Please accept the Terms and Conditions',
        wallet: 'Wallet',
        gram: 'gram',
        nohistoryfound: 'No history found',
        fillupto4decimal: 'Value needs to be between 0 and 10 gram. Allowed till 4 decimal places.',
        fillamountupto2decimal: 'Amonut needs to be between 1 and 10000 Rs. Allowed till 2 decimal places.',
        somethingwentwrong: 'Something went wrong. Please try again!',
        notauthorised: 'You are not Authorised!',
        notregistered: 'You are not Registered!',
        nompoint_sellandbuy: 'You donot have enough Gems on selling without buying!',
        successfullysoldgold: 'Gold selling successful! Your money will be transferred to your bank account.',
        enoughgoldtosell: 'You do not have enough gold to sell',
        enoughgold: 'You do not have enough gold',
        amountlessthanrs2: 'Amonut needs to be more than Rupee 1. Allowed till 2 decimal places.',
        amountcannotzero: 'Amount cannot be zero. Allowed till 4 decimal places.',
        acceptterms: 'I accept the Terms and Conditions',
        upicode: 'UPI code',
        lessthan1: 'Cannot purchase for less than Rupee 1',
        time: 'Time Remaining',
        transferdescription: 'Amount transfer description',
        refundinbank: 'Refund in Bank',
        refundinwallet: 'Refund in Wallet',
        confirmbankaccount: 'Confirmed bank account number does not match',
        delivery: 'Delivery',
        deliver_gold: 'Now get your 24K gold balance delivered to your door step in the form of your Gold Coins.',
        howitwork: 'HOW IT WORKS',
        sellerproceed: 'SELECT SELLER TO PROCEED',
        choosegoldcoin: 'Select Gold Coin',
        paymakingcharges: 'Pay Making Charges',
        gethomedelivery: 'Get Home Delivery',
        constructionfee: 'Construction fee',
        freeshipping: 'Free Shipping',
        address_delivery: 'Delivery Address',
        available_purchasebalance: 'Your current digital gold balance available in your Locker is low. You need more digital gold to place this order. Please buy gold to proceed further.',
        product_details: 'Product details',
        gift_lockerbalance: 'Your locker balance',
        add_newaddress: 'Add New Address',
        specify_deliveryaddress: 'Specify delivery address',
        fullname: 'Full Name',
        pincode: 'PIN Code',
        house_no: 'House Number',
        mobile_no: 'Mobile Number',
        digit_mobile_no: '10 Digit Mobile Number',
        landmark: 'Landmark',
        landmark_location: 'Near by famous location',
        save_address: 'Save Address',
        gold_balance: 'Gold Balance',
        return_policy: 'Return Policy',
        fill_fullname: 'Please fill in the full name',
        fill_state: 'Please fill in the state',
        fill_houseno: 'Please fill in the correct house number',
        fill_mobileno: 'Please fill in the correct mobile number',
        fill_street: 'Please fill in the correct street',
        fill_landmark: 'Please fill in the correct landmark',
        product: 'Product',
        new_address: '+ Add New Address',
        return_policydescription: 'No Return / Replacement Allowed - Returns or Replacements are not accepted by the seller for this product. Cancellation not allowed - Cancellation is not allowed for this product once ordered.',
        product_descrp1: 'Please select this product only if you have sufficient digital gold balance. In case of insufficient gold balance, this order will be rejected',
        product_descrp2: 'Each coin is sealed in a signed, numbered protective certificate packaging that guarantees metal content, weight, and quality.',
        product_descrp3: 'The coin is built using the highest Swiss engineering skills in a modern, state-of-the-art refinery. SAFE-GOLD is the only refinery in India recognized by LBMA (London Bullion Market Association), the global standard for gold and silver.',
        product_descrp4: 'Easy buyback available in SAFE-GOLD store on production of bill at 100% gold price on that day.',
        delivery_date: 'Delivery Date',
        refundpaytm: 'Refund in Paytm',
        goldproduct: 'Gold Product',
        gift_lockerbalancce: 'Your Locker Balance',
        giftyourself: 'Gift your dear ones',
        mobilenumber: 'Mobile Number',
        enteramountgold: 'Enter Amount(₹)',
        message: 'Message',
        gold_gifthere: 'Here is your Gold Gift.',
        goldgift: 'Gift Gold',
        gifthistory: 'Gift History',
        myorders: 'My Orders',
        note: 'Note',
        transactionid: 'Transaction Id',
        invoiceid: 'Invoice Id',
        sinceamountlessthan: 'Since, your amount is less than Rs. 50',
        amountshow: 'amount',
        transferredpaytmwallet: 'will be transferred to your Paytm Wallet',
        gift: 'Gift',
        entervalid_mobileno: 'Enter a valid Mobile Number',
        enter_goldamount: 'Enter Gold Amount',
        enough_gold: 'You do not have enough Gold available',
        successfully_giftedgold: 'You have successfully gifted gold',
        no_history: 'No History Available',
        trackorder: 'Track Order',
        deliveryestimate: 'Delivery Estimate:',
        order_id: 'Order Id',
        receiver_notregister: 'Receiver is not registered'
    },
    bn: {
        gold: 'স্বর্ণ',
        gems: "জেমস",
        locker: 'দেরাজ',
        buy: 'ખરીદો',
        buybuttontxt: 'ખરીદો ₹ {mintingcost}',
        confirm: 'নিশ্চিত করা',
        cancel: 'বাতিল',
        goldlockerbalance: 'সোনার লকারের ভারসাম্য',
        askedquestion: 'প্রায়শই জিজ্ঞাসিত প্রশ্নাবলী',
        recenttransaction: 'সাম্প্রতিক লেনদেন',
        choosegoldseller: 'সোনার বিক্রেতা চয়ন করুন',
        buyingrams: 'গ্রামে কিনুন',
        buyinamount: 'পরিমাণে কিনুন',
        sellingrams: 'গ্রামে বিক্রি করুন',
        sellinamount: 'পরিমাণে বিক্রয়',
        successfulpayment: 'সফল সোনার ক্রয়',
        unsuccessfulpayment: 'আপনার লেনদেন ব্যর্থ হয়েছিল',
        selleragent: 'বিক্রেতা এজেন্ট',
        seelocker: 'লকারটি দেখুন',
        paymentreview: 'পেমেন্ট পর্যালোচনা',
        basedongoldprise: 'সোনার দামের উপর ভিত্তি করে',
        boughtgold: 'আপনার কেনা সোনা',
        discount: 'ডিসকাউন্ট',
        paywithdiscount: 'ছাড় সহ পরিশোধ করুন',
        processingcharge: 'ছাড় সহ পরিশোধ করুন',
        pay: 'আপনি দিতে হবে',
        sellgold: 'সোনার বিক্রি',
        buygold: 'সোনা কিনুন',
        registration: 'নিবন্ধন',
        consumerdetail: 'গ্রাহক বিশদ',
        username: 'ব্যবহারকারীর নাম',
        email: 'ইমেইল',
        phone_no: 'ফোন নম্বর',
        address: 'ঠিকানা',
        street: 'রাস্তা',
        pincode: 'পিনকোড',
        city: 'শহর',
        state: 'রাষ্ট্র',
        aaddhar_no: 'আধার নম্বর',
        pan_number: 'প্যান নম্বর',
        account_name: 'ব্যাংক ধারকের নাম',
        bankaccount: 'ব্যাংক হিসাব',
        re_bank_aacount: 'পুনরায় ব্যাংক অ্যাকাউন্ট',
        ifsc_code: 'ifsc কোড',
        bank: 'ব্যাংক',
        submit: 'জমা দিতে',
        include_gst: '3% জিএসটি অন্তর্ভুক্ত',
        enteramount: 'পরিমান লিখুন',
        total_amount: 'মোট পরিমাণ',
        purity: 'বিশুদ্ধতা',
        fill_username: 'ব্যবহারকারীর নাম পূরণ করুন',
        fill_phoneno: 'দয়া করে সঠিক ফোন নম্বরটি পূরণ করুন',
        fill_pincode: 'দয়া করে সঠিক পিনকোডটি পূরণ করুন',
        fill_city: 'দয়া করে সঠিক শহরটি পূরণ করুন',
        fill_aadhar: 'সঠিক আধারটি পূরণ করুন',
        fill_panno: 'দয়া করে সঠিক প্যান নম্বরটি পূরণ করুন',
        holder_name: 'সঠিক ব্যাঙ্ক অ্যাকাউন্টধারীর নাম পূরণ করুন',
        fill_bankaccount: 'দয়া করে সঠিক ব্যাংক অ্যাকাউন্টটি পূরণ করুন',
        fill_ifsccode: 'সঠিক ifsc কোড পূরণ করুন',
        fill_upicode: 'সঠিক আপী কোডটি পূরণ করুন',
        termsandcondition: 'শর্তাবলী গ্রহণ করুন দয়া করে',
        nohistoryfound: 'কোনও ইতিহাস পাওয়া যায় নি',
        fillupto4decimal: 'শূন্য এবং 10 গ্রামের বেশি হতে পারে না এবং কেবল 4 দশমিক স্থান অনুমতি দেয়',
        fillamountupto2decimal: 'পরিমাণ 1 টাকার চেয়ে কম বা 10000 টাকার বেশি হতে পারে না only কেবলমাত্র 2 দশমিক স্থানে অনুমোদিত।',
        somethingwentwrong: 'কিছু ভুল হয়েছে, আবার চেষ্টা করুন!',
        notauthorised: 'আপনি অনুমোদিত না!',
        notregistered: 'আপনি নিবন্ধিত না!',
        nompoint_sellandbuy: 'ব্যয় না করে আপনার এমপিপয়েন্টে পাস করুন!',
        successfullysoldgold: 'আপনি সফলভাবে স্বর্ণ বিক্রি করেছেন। আপনার অর্থ আপনার ব্যাংক অ্যাকাউন্টে স্থানান্তরিত হবে',
        enoughgoldtosell: 'আপনার বিক্রি করার মতো পর্যাপ্ত সোনা নেই',
        enoughgold: 'আপনার কাছে পর্যাপ্ত সোনা নেই',
        amountlessthanrs2: 'পরিমাণ ১ টাকার চেয়ে কম হতে পারে না 2 কেবলমাত্র 2 দশমিক স্থানে অনুমোদিত',
        amountcannotzero: 'পরিমাণ শূন্য হতে পারে না। কেবলমাত্র 4 দশমিক স্থান পর্যন্ত অনুমোদিত',
        upicode: 'UPI কোড',
        lessthan1: '1 টাকারও কম কিনতে পারবেন না',
        time: 'অবশিষ্ট সময়',
        gram: 'গ্রাম',
        wallet: 'মানিব্যাগ',
        transferdescription: 'পরিমাণ স্থানান্তর বিবরণ',
        refundinbank: 'ব্যাংকে রিফান্ড',
        refundinwallet: 'ওয়ালেটে টাকা ফেরত',
        confirmbankaccount: 'ব্যাঙ্ক অ্যাকাউন্ট নম্বর মেলে না তা নিশ্চিত করুন',
        delivery: 'বিলি',
        deliver_gold: 'এখন আপনার সোনার মুদ্রার আকারে আপনার 24k স্বর্ণের ভারসাম্যটি আপনার দরজায় পৌঁছে দিন।',
        howitwork: 'এটা কিভাবে কাজ করে',
        sellerproceed: 'প্রসেসড বিক্রয়কারী নির্বাচন করুন',
        choosegoldcoin: 'সোনার মুদ্রা চয়ন করুন',
        paymakingcharges: 'মেকিং চার্জ',
        gethomedelivery: 'হোম ডেলিভারি পান',
        constructionfee: 'নির্মাণ ফি',
        freeshipping: 'বিনামূল্যে পরিবহন',
        address_delivery: 'আপনার ঠিকানা বিতরণ',
        available_purchasebalance: 'আপনার সোনার ব্যালেন্স ক্রয়ের ব্যালেন্সের চেয়ে কম। প্রথমে সোনা কিনুন',
        product_details: 'পণ্যের বিবরণ',
        add_newaddress: 'নতুন ঠিকানা যোগ করুন',
        specify_deliveryaddress: 'ডিসেম্বর জানুন',
        fullname: 'পুরো নাম',
        pincode: 'জিপ কোড',
        house_no: 'বাড়ির নম্বর',
        mobile_no: 'মোবাইল নম্বর',
        digit_mobile_no: '10 শতকরা মোবাইল নাম্বার',
        landmark: 'বৈশিষ্ট্য',
        landmark_location: 'কাছাকাছি / বিখ্যাত অবস্থান',
        save_address: 'ঠিকানা সংরক্ষণ করুন',
        gold_balance: 'সোনার ভারসাম্য',
        return_policy: 'প্রত্যাবর্তন নীতিমালা',
        fill_fullname: 'পুরো নাম পূরণ করুন',
        fill_state: 'রাষ্ট্র পূরণ করুন',
        fill_houseno: 'দয়া করে সঠিক বাড়ির নম্বরটি পূরণ করুন',
        fill_mobileno: 'সঠিক মোবাইল নম্বর পূরণ করুন',
        fill_street: 'সঠিক রাস্তায় পূরণ করুন',
        fill_landmark: 'দয়া করে সঠিক ল্যান্ডমার্কটি পূরণ করুন',
        product: 'প্রোডাক্ট',
        new_address: '+ নতুন ঠিকানা যোগ করুন',
        return_policydescription: 'কোনও রিটার্ন / প্রতিস্থাপনের অনুমতি নেই - এই পণ্যটির জন্য বিক্রয়ক দ্বারা রিটার্ন বা প্রতিস্থাপন গ্রহণ করা হয় না Cancel বাতিলকরণ অনুমোদিত নয় - একবার আদেশ দেওয়ার পরে এই পণ্যটির জন্য বাতিলকরণ অনুমোদিত নয়।',
        product_descrp1: 'আপনার যদি পর্যাপ্ত ডিজিটাল সোনার ব্যালেন্স থাকে তবে দয়া করে এই পণ্যটি নির্বাচন করুন। অপর্যাপ্ত স্বর্ণের ভারসাম্যের ক্ষেত্রে, এই আদেশটি প্রত্যাখ্যান করা হবে',
        product_descrp2: 'প্রতিটি মুদ্রা একটি স্বাক্ষরিত, সংখ্যাযুক্ত প্রতিরক্ষামূলক শংসাপত্রের প্যাকেজিংয়ে সিল করা হয় যা ধাতব সামগ্রী, ওজন এবং মানের গ্যারান্টি দেয়।',
        product_descrp3: 'মুদ্রাটি একটি আধুনিক, অত্যাধুনিক শোধনাগারের সর্বোচ্চ সুইস ইঞ্জিনিয়ারিং দক্ষতা ব্যবহার করে তৈরি করা হয়েছে is নিরাপদ-গোল্ড ভারতের একমাত্র শোধনাগার যা এলবিএমএ (লন্ডন বুলিয়ান মার্কেট অ্যাসোসিয়েশন) স্বীকৃত, স্বর্ণ ও রৌপ্যের জন্য বিশ্বমানের।',
        product_descrp4: 'সেদিন 100% সোনার দামে বিল উত্পাদনে নিরাপদ-গোল্ড স্টোরে সহজ বায়ব্যাক পাওয়া যায়।',
        delivery_date: 'বিতরণ তারিখ',
        refundpaytm: 'paytm এ ফেরত',
        goldproduct: 'সোনার পণ্য',
        gift_lockerbalance: 'আপনার লকার ব্যালেন্স',
        giftyourself: 'নিজেকে উপহার দিন',
        mobilenumber: 'মোবাইল নম্বর',
        enteramountgold: 'টাকার পরিমাণ স্বর্ণ প্রবেশ করুন',
        message: 'বার্তা',
        gold_gifthere: 'এখানে আপনার স্বর্ণের উপহার',
        goldgift: 'উপহার স্বর্ণ',
        gifthistory: 'উপহারের ইতিহাস',
        myorders: 'আমার আদেশ',
        note: 'নোট',
        transactionid: 'লেনদেন নাম্বার',
        invoiceid: 'চালান আইডি',
        sinceamountlessthan: 'যেহেতু, আপনার পরিমাণ 50 এরও কম',
        amountshow: 'পরিমাণ',
        transferredpaytmwallet: 'আপনার পেটিএম ওয়ালেটে স্থানান্তরিত হবে',
        gift: 'উপহার',
        entervalid_mobileno: 'একটি বৈধ মোবাইল নম্বর লিখুন',
        enter_goldamount: 'সোনার পরিমাণ প্রবেশ করান',
        enough_gold: 'আপনার কাছে পর্যাপ্ত সোনা নেই',
        successfully_giftedgold: 'আপনি সাফল্যের সাথে স্বর্ণ উপহার দিয়েছেন',
        no_history: 'কোনও ইতিহাস উপলভ্য নয়',
        trackorder: 'ট্র্যাক আদেশ',
        deliveryestimate: 'ডেলিভারি অনুমান:',
        order_id: 'অর্ডার আইডি',
        receiver_notregister: 'প্রাপক নিবন্ধভুক্ত নয়'
    },
    hi: {
        gold: 'सोना',
        gems: "जेम्स",
        locker: 'तिजोरी',
        buy: 'खरीदें',
        buybuttontxt: 'ख़रीदे ₹ {mintingcost}',
        sell: 'बेंचे',
        confirm: 'पुष्टि करें',
        cancel: 'रद्द करें',
        goldlockerbalance: 'गोल्ड लॉकर बैलेंस',
        askedquestion: 'अक्सर पूछे जाने वाले प्रश्न',
        recenttransaction: 'हाल ही में लेन-देन',
        choosegoldseller: 'गोल्ड सेलर चुनें',
        buyingrams: 'ग्राम में खरीदें',
        buyinamount: 'राशि में खरीदें',
        sellingrams: 'ग्राम में बेचे',
        sellinamount: 'राशि में बेचे',
        successfulpayment: 'सोने की सफल खरीद',
        unsuccessfulpayment: 'आपका लेन-देन असफल हुआ',
        selleragent: 'विक्रेता एजेंट',
        seelocker: 'लॉकर देखें',
        paymentreview: 'भुगतान की समीक्षा',
        basedongoldprise: 'गोल्ड प्राइस के आधार पर',
        boughtgold: 'आप खरीद रहे है',
        discount: 'छूट',
        paywithdiscount: 'भुगतान (छूट के साथ)',
        processingcharge: 'प्रोसेसिंग चार्ज',
        pay: 'आप भुगतान करोगे',
        sellgold: 'सोना बेचे',
        buygold: 'सोना ख़रीदे',
        registration: 'पंजीकरण',
        consumerdetail: 'उपभोक्ता विवरण',
        username: 'उपयोगकर्ता नाम',
        email: 'ईमेल',
        phone_no: 'मोबाइल नंबर',
        address: 'पता',
        street: 'सड़क',
        pincode: 'पिन कोड',
        city: 'शहर',
        state: 'राज्य',
        aaddhar_no: 'आधार नंबर',
        pan_number: 'पैन नंबर',
        account_name: 'बैंक होल्डर का नाम',
        bankaccount: 'बैंक खाता',
        re_bank_aacount: 'पुनः बैंक खाता',
        ifsc_code: 'IFSC कोड',
        bank: 'बैंक',
        submit: 'जमा करे',
        include_gst: '3% जीएसटी शामिल करें',
        enteramount: 'राशी डालें',
        total_amount: 'कुल रकम',
        purity: 'शुद्धता',
        whatis_safeGold: 'सेफगोल्ड क्या है?',
        fill_username: 'कृपया उपयोगकर्ता नाम भरें',
        fill_phoneno: 'कृपया सही फोन नंबर भरें',
        fill_pincode: 'कृपया सही पिनकोड भरें',
        fill_city: 'कृपया सही शहर भरें',
        fill_aadhar: 'कृपया सही आधार नंबर भरें।',
        fill_panno: 'कृपया सही पैन नंबर भरें।',
        holder_name: 'कृपया सही बैंक खाता धारक का नाम भरें',
        fill_bankaccount: 'कृपया सही बैंक खाता भरें',
        fill_ifsccode: 'कृपया सही IFSC कोड भरें',
        fill_upicode: 'कृपया सही UPI कोड भरें',
        termsandcondition: 'कृपया नियम और शर्तें स्वीकार करें',
        wallet: 'वॉलेट',
        gram: 'ग्राम',
        nohistoryfound: 'कोई हिस्ट्री नहीं मिला',
        fillupto4decimal: 'शून्य नहीं हो सकता है और 10 ग्राम से अधिक नहीं हो सकता है। केवल 4 दशमलव स्थानों की अनुमति है',
        fillamountupto2decimal: 'राशि 1 रुपये से कम या 10000 रुपये से अधिक नहीं हो सकती है। केवल 2 दशमलव स्थानों तक अनुमत है।',
        somethingwentwrong: 'कुछ गलत हो गया। कृपया पुन: प्रयास करें!',
        notauthorised: 'आप अधिकृत नहीं हैं!',
        notregistered: 'आप पंजीकृत नहीं हैं!',
        nompoint_sellandbuy: 'आपके पास खरीदने के बिना बेचने पर पर्याप्त एमपी पॉइंट हैं!',
        successfullysoldgold: 'सोना बिकने में सफल! आपका पैसा आपके बैंक खाते में स्थानांतरित कर दिया जाएगा।',
        enoughgoldtosell: 'आपके पास बेचने के लिए पर्याप्त सोना नहीं है!',
        enoughgold: 'आपके पास पर्याप्त सोना नहीं है!',
        amountlessthanrs2: 'राशि 1 रुपये से कम नहीं हो सकती है। केवल 2 दशमलव स्थानों तक अनुमत है',
        amountcannotzero: 'राशि शून्य नहीं हो सकती। 4 दशमलव स्थानों तक अनुमति है।',
        acceptterms: 'मैं नियम और शर्त स्वीकार करता हूं',
        upicode: 'UPI कोड',
        lessthan1: '1 रुपये से कम की खरीद नहीं कर सकते',
        time: 'समय शेष',
        transferdescription: 'राशि ट्रान्सफर विवरण',
        refundinbank: 'बैंक में रिफंड',
        refundinwallet: 'वॉलेट में रिफंड',
        confirmbankaccount: 'पुष्टि की गई बैंक खाता संख्या मेल नहीं खाती है',
        delivery: 'डिलीवरी',
        deliver_gold: 'अब अपने २४क सोने को सिक्के के रूप मैं अपने घर पे डिलीवर करवाएं।',
        howitwork: 'यह काम किस प्रकार करता है',
        sellerproceed: 'चयनित करने के लिए विक्रेता का चयन करें',
        choosegoldcoin: 'सोने का सिक्का चुनें',
        paymakingcharges: 'पे मेकिंग चार्जेस',
        gethomedelivery: 'होम डिलीवरी कराएं',
        constructionfee: 'निर्माण शुल्क',
        freeshipping: 'मुफ़्त शिपिंग',
        address_delivery: 'डिलिवरी का पता',
        available_purchasebalance: 'आपके लॉकर में उपलब्ध आपका वर्तमान डिजिटल गोल्ड बैलेंस कम है। इस आदेश को रखने के लिए आपको अधिक डिजिटल सोना चाहिए। कृपया आगे बढ़ने के लिए सोना खरीदें।',
        product_details: 'प्रोडक्ट डिलीवरी',
        add_newaddress: 'नया पता जोड़ें',
        specify_deliveryaddress: 'डिलीवरी पता बताएं',
        fullname: 'पूरा नाम',
        pincode: 'पिन कोड',
        house_no: 'घर का नंबर',
        mobile_no: 'मोबाइल नंबर',
        digit_mobile_no: '10 अंकों का मोबाइल नंबर',
        landmark: 'लैंडमार्क्स',
        landmark_location: 'प्रसिद्ध स्थान के पास',
        save_address: 'पता सहेजें',
        gold_balance: 'गोल्ड बैलेंस',
        return_policy: 'वापसी नीति',
        fill_fullname: 'कृपया पूरा नाम भरें',
        fill_state: 'कृपया राज्य भरें',
        fill_houseno: 'कृपया सही घर संख्या भरें',
        fill_mobileno: 'कृपया सही मोबाइल नंबर भरें',
        fill_street: 'कृपया सही गली भरें',
        fill_landmark: 'कृपया सही लैंडमार्क भरें',
        product: 'प्रोडक्ट',
        new_address: '+ नया पता जोड़ें',
        return_policydescription: 'कोई रिटर्न / रिप्लेसमेंट अनुमति नहीं - विक्रेता द्वारा इस उत्पाद के लिए रिटर्न या रिप्लेसमेंट स्वीकार नहीं किए जाते हैं। रद्दीकरण की अनुमति नहीं - एक बार आदेश दिए जाने पर इस उत्पाद के लिए रद्दीकरण की अनुमति नहीं है।',
        product_descrp1: 'कृपया इस उत्पाद का चयन केवल तभी करें जब आपके पास पर्याप्त डिजिटल गोल्ड बैलेंस हो। अपर्याप्त सोने के संतुलन के मामले में, इस आदेश को अस्वीकार कर दिया जाएगा',
        product_descrp2: 'प्रत्येक सिक्के को एक हस्ताक्षरित, क्रमांकित सुरक्षात्मक प्रमाणपत्र पैकेजिंग में सील किया जाता है जो धातु सामग्री, वजन और गुणवत्ता की गारंटी देता है।',
        product_descrp3: 'सिक्का एक आधुनिक, अत्याधुनिक रिफाइनरी में उच्चतम स्विस इंजीनियरिंग कौशल का उपयोग करके बनाया गया है। SAFE-GOLD भारत की एकमात्र रिफाइनरी है जिसे LBMA (लंदन बुलियन मार्केट एसोसिएशन) द्वारा मान्यता प्राप्त है, जो सोने और चांदी के लिए वैश्विक मानक है।',
        product_descrp4: 'उस दिन 100% सोने के मूल्य पर बिल के उत्पादन पर सेफ-गोल्ड स्टोर में उपलब्ध आसान बायबैक।',
        delivery_date: 'डिलीवरी की तारीख',
        refundpaytm: 'पेटीएम में रिफंड',
        goldproduct: 'गोल्ड प्रोडक्ट',
        gift_lockerbalance: 'आपका लॉकर बैलेंस',
        giftyourself: 'अपने प्रियजनों को उपहार दें',
        mobilenumber: 'मोबाइल नंबर',
        enteramountgold: 'राशि दर्ज करें (₹)',
        message: 'सूचना',
        gold_gifthere: 'यह आपका गोल्ड गिफ्ट है।',
        goldgift: 'गोल्ड गिफ्ट करें',
        gifthistory: 'गिफ्ट हिस्ट्री',
        myorders: 'मेरे ऑर्डर',
        note: 'नोट',
        transactionid: 'लेन-देन आईडी',
        invoiceid: 'इन्वॉइस आईडी',
        sinceamountlessthan: 'चूंकि, आपकी राशि 50 से कम है',
        amountshow: 'इसलिए',
        transferredpaytmwallet: 'पर आपके पेटीएम वॉलेट में ट्रांसफर किया जाएगा',
        gift: 'गिफ्ट',
        entervalid_mobileno: 'मान्य मोबाइल नंबर दर्ज करें',
        enter_goldamount: 'गोल्ड राशि दर्ज करें',
        enough_gold: 'आपके पास पर्याप्त गोल्ड उपलब्ध नहीं है',
        successfully_giftedgold: 'आपने सफलतापूर्वक सोना गिफ्ट किया है',
        no_history: 'कोई हिस्ट्री उपलब्ध नहीं है',
        trackorder: 'ऑर्डर पर नज़र रखें',
        deliveryestimate: 'डिलिवरी का समय',
        order_id: 'ऑर्डर आईडी',
        receiver_notregister: 'रिसीवर पंजीकृत नहीं है'
    },
    gu: {
        gold: 'સોનું',
        gems: "જેમ્સ",
        locker: 'લોકર',
        buy: 'ખરીદો',
        buybuttontxt: 'ખરીદો ₹ {mintingcost}',
        sell: 'બેશે',
        confirm: 'ખાતરી કરો',
        cancel: 'રદ કરો',
        goldlockerbalance: 'ગોલ્ડ લોકર બેલેન્સ',
        askedquestion: 'વારંવાર પૂછાતા પ્રશ્નો',
        recenttransaction: 'તાજેતરનો વ્યવહાર',
        choosegoldseller: 'સોના વેચનારને પસંદ કરો',
        buyingrams: 'ગ્રામમાં ખરીદો',
        buyinamount: 'ग्राम में खरीदें',
        sellingrams: 'ગ્રામમાં વેચાય છે',
        sellinamount: 'રકમ વેચે છે',
        successfulpayment: 'સોનાની સફળ ખરીદી',
        unsuccessfulpayment: 'તમારો વ્યવહાર નિષ્ફળ ગયો',
        selleragent: 'વિક્રેતા એજન્ટ',
        seelocker: 'લોકર જુઓ',
        paymentreview: 'ચુકવણી સમીક્ષા',
        basedongoldprise: 'સોનાના ભાવના આધારે',
        boughtgold: 'તમારું ખરીદેલું સોનું',
        discount: 'છૂટ',
        paywithdiscount: 'ડિસ્કાઉન્ટ સાથે ચૂકવણી',
        processingcharge: 'પ્રોસેસીંગ ચાર્જ',
        pay: 'તમે ચૂકવણી કરશે',
        sellgold: 'સોનું વેચો',
        buygold: 'સોનું ખરીદો',
        registration: 'નોંધણી',
        consumerdetail: 'ગ્રાહક વિગતો',
        username: 'વપરાશકર્તા નામ',
        email: 'ઇમેઇલ',
        phone_no: 'ફોન નંબર',
        address: 'સરનામું',
        street: 'શેરી',
        pincode: 'પીન કોડ',
        city: 'શહેર',
        state: 'રાજ્ય',
        aaddhar_no: 'આધાર નંબર',
        pan_number: 'પાન નંબર',
        account_name: 'બેંક ધારકનું નામ',
        bankaccount: 'બેંક એકાઉન્ટ',
        re_bank_aacount: 'ફરી બેંક ખાતું',
        ifsc_code: 'ifsc કોડ',
        bank: 'બેંક',
        submit: 'સબમિટ કરો',
        include_gst: '3% જીએસટીનો સમાવેશ',
        enteramount: 'રકમ દાખલ કરો',
        total_amount: 'કુલ રકમ',
        purity: 'શુદ્ધતા',
        fill_username: 'કૃપા કરીને વપરાશકર્તા નામ ભરો',
        fill_phoneno: 'કૃપા કરી સાચો ફોન નંબર ભરો',
        fill_pincode: 'કૃપા કરી સાચો પિનકોડ ભરો',
        fill_city: 'કૃપા કરી સાચો શહેર ભરો',
        fill_aadhar: 'કૃપા કરી સાચો આધાર ભરો',
        fill_panno: 'કૃપા કરી સાચો પાન નંબર ભરો',
        holder_name: 'કૃપા કરી સાચા બેંક ખાતા ધારકનું નામ ભરો',
        fill_bankaccount: 'કૃપા કરી સાચો બેંક ખાતું ભરો',
        fill_ifsccode: 'કૃપા કરી સાચો આઇ.એફ.એસ. કોડ ભરો',
        fill_upicode: 'કૃપા કરી સાચી ઉપી કોડ ભરો',
        termsandcondition: 'કૃપા કરીને નિયમો અને શરતો સ્વીકારો',
        nohistoryfound: 'કોઈ ઇતિહાસ મળ્યો નથી',
        fillupto4decimal: 'શૂન્ય અને 10 ગ્રામથી વધુ હોઈ શકતું નથી અને ફક્ત 4 દશાંશ સ્થાનો મંજૂરી આપે છે',
        fillamountupto2decimal: 'રકમ 1 રૂપિયા કરતા ઓછી અથવા 10000 રૂપિયા કરતાં વધુ હોઇ શકે નહીં. ફક્ત 2 દશાંશ સ્થળો સુધી મંજૂરી આપવામાં આવે છે.',
        somethingwentwrong: 'કંઈક ખોટું થયું, ફરીથી પ્રયાસ કરો!',
        notauthorised: 'તમે અધિકૃત નથી!',
        notregistered: 'તમે નોંધાયેલા નથી!',
        nompoint_sellandbuy: 'તમારા સદસ્યોની નોંધણી વગર સાંસદ સ્થાનો નથી!',
        successfullysoldgold: 'તમે સફળતાપૂર્વક સોનું વેચી દીધું છે. તમારા પૈસા તમારા બેંક ખાતામાં સ્થાનાંતરિત કરવામાં આવશે',
        enoughgoldtosell: 'તમારી પાસે વેચવા માટે પૂરતું સોનું નથી',
        enoughgold: 'તમારી પાસે પૂરતું સોનું નથી',
        amountlessthanrs2: 'રકમ રૂપિયા 1 કરતા ઓછી હોઇ નહીં. ફક્ત 2 દશાંશ સ્થાનો સુધી મંજૂરી આપવામાં આવે છે',
        amountcannotzero: 'રકમ શૂન્ય ન હોઈ શકે. માત્ર 4 દશાંશ સ્થાનો સુધી મંજૂરી છે',
        upicode: 'UPI કોડ',
        lessthan1: '1 રૂપિયા કરતા ઓછી ખરીદી શકતા નથી',
        time: 'બાકી સમય',
        gram: 'ગામ',
        wallet: 'વૉલેટ ',
        transferdescription: 'રકમ ટ્રાન્સફર વર્ણન',
        refundinbank: 'બેંકમાં રિફંડ',
        refundinwallet: 'વletલેટમાં રિફંડ',
        confirmbankaccount: 'પુષ્ટિ કરો કે બેંક એકાઉન્ટ નંબર મેળ ખાતો નથી',
        delivery: 'ડિલિવરી',
        deliver_gold: 'હવે તમારા સોનાના સિક્કાના રૂપમાં તમારા 24k ગોલ્ડ બેલેન્સને તમારા દરવાજા પર પહોંચાડો.',
        howitwork: 'તે કેવી રીતે કાર્ય કરે છે',
        sellerproceed: 'આગળ વધવા માટે વિક્રેતા પસંદ કરો',
        choosegoldcoin: 'સોનાનો સિક્કો પસંદ કરો',
        paymakingcharges: 'ચુકવણી કરવાનો ચાર્જ',
        gethomedelivery: 'હોમ ડિલિવરી મેળવો',
        constructionfee: 'બાંધકામ ફી',
        freeshipping: 'મફત શિપિંગ',
        address_delivery: 'તમારી સરનામાં વિતરણ',
        available_purchasebalance: 'તમારું સોનું સિલક ખરીદી બેલેન્સ કરતા ઓછું છે. કૃપા કરીને પહેલા સોનું ખરીદો.',
        product_details: 'ઉત્પાદન વિગતો',
        add_newaddress: 'નવું સરનામું ઉમેરો',
        specify_deliveryaddress: 'ડિલિવરી સરનામું સ્પષ્ટ કરો',
        fullname: 'પૂરું નામ',
        pincode: 'પિન કોડ',
        house_no: 'મકાન નંબર',
        mobile_no: 'મોબાઈલ નંબર',
        digit_mobile_no: '10 નંબરનો મોબાઇલ નંબર',
        landmark: 'સીમાચિહ્ન',
        landmark_location: 'નજીક / પ્રખ્યાત સ્થાન',
        save_address: 'સરનામું સાચવો',
        gold_balance: 'ગોલ્ડ બેલેન્સ',
        return_policy: 'રીટર્ન નીતિ',
        fill_fullname: 'કૃપા કરી પૂરું નામ ભરો',
        fill_state: 'કૃપા કરીને રાજ્ય ભરો',
        fill_houseno: 'કૃપા કરી ઘરનો સાચો નંબર ભરો',
        fill_mobileno: 'કૃપા કરી સાચો મોબાઇલ નંબર ભરો',
        fill_street: 'કૃપા કરી સાચી શેરી ભરો',
        fill_landmark: 'કૃપા કરી સાચો સીમાચિહ્ન ભરો',
        product: 'ઉત્પાદન',
        new_address: '+ નવું સરનામું ઉમેરો',
        return_policydescription: 'કોઈ રીટર્ન / રિપ્લેસમેન્ટની મંજૂરી નથી - આ ઉત્પાદન માટે વેચનાર દ્વારા વળતર અથવા ફેરબદલ સ્વીકારવામાં આવતાં નથી રદ કરવાની મંજૂરી નથી - એકવાર ઓર્ડર આપ્યા પછી આ ઉત્પાદન માટે રદ કરવાની મંજૂરી નથી.',
        product_descrp1: 'કૃપા કરીને ફક્ત ત્યારે જ આ ઉત્પાદનને પસંદ કરો જો તમારી પાસે પૂરતી ડિજિટલ ગોલ્ડ બેલેન્સ છે. અપૂરતા ગોલ્ડ બેલેન્સના કિસ્સામાં, આ ઓર્ડર નામંજૂર કરવામાં આવશે',
        product_descrp2: 'દરેક સિક્કો સહી કરેલા, નંબરવાળી રક્ષણાત્મક પ્રમાણપત્ર પેકેજિંગમાં સીલ કરવામાં આવે છે જે મેટલ સામગ્રી, વજન અને ગુણવત્તાની બાંયધરી આપે છે.',
        product_descrp3: 'આધુનિક, અત્યાધુનિક રિફાઈનરીમાં સ્વિસ એન્જિનિયરિંગ કુશળતાનો ઉપયોગ કરીને આ સિક્કો બનાવવામાં આવ્યો છે. સેફ-ગોલ્ડ એ ભારતની એકમાત્ર રિફાઇનરી છે જે એલબીએમએ (લંડન બુલિયન માર્કેટ એસોસિએશન) દ્વારા માન્યતા પ્રાપ્ત છે, જે સોના અને ચાંદીના વૈશ્વિક ધોરણ છે.',
        product_descrp4: 'તે દિવસે 100% સોનાના ભાવે બિલના ઉત્પાદન પર સલામત-ગોલ્ડ સ્ટોરમાં સરળ બાયબેક ઉપલબ્ધ છે.',
        delivery_date: 'વિતરણ તારીખ',
        refundpaytm: 'paytm માં રિફંડ',
        goldproduct: 'સોનાનું ઉત્પાદન',
        gift_lockerbalance: 'તમારું લોકર બેલેન્સ',
        giftyourself: 'જાતે ભેટ',
        mobilenumber: 'મોબાઇલ નંબર',
        enteramountgold: 'રકમમાં સોનું દાખલ કરો',
        message: 'સંદેશ',
        gold_gifthere: 'અહીં તમારી ગોલ્ડ ભેટ',
        goldgift: 'ભેટ સોનું',
        gifthistory: 'ભેટ ઇતિહાસ',
        myorders: 'મારા ઓર્ડર',
        note: 'નોંધ',
        transactionid: 'ટ્રાન્ઝેક્શન આઈડી',
        invoiceid: 'ભરતિયું આઈડી',
        sinceamountlessthan: 'તેથી, તમારી રકમ 50 કરતા ઓછી છે',
        amountshow: 'રકમ',
        transferredpaytmwallet: 'તમારા પેટીએમ વલેટ પર સ્થાનાંતરિત કરવામાં આવશે',
        gift: 'ભેટ',
        entervalid_mobileno: 'માન્ય મોબાઇલ નંબર દાખલ કરો',
        enter_goldamount: 'સોનાની રકમ દાખલ કરો',
        enough_gold: 'તમારી પાસે પૂરતું સોનું નથી',
        successfully_giftedgold: 'તમે સફળતાપૂર્વક સોનું ભેટ કર્યું છે',
        no_history: 'કોઈ ઇતિહાસ ઉપલબ્ધ નથી',
        trackorder: 'ટ્રેક ઓર્ડર',
        deliveryestimate: 'અંદાજીત વિતરણ:',
        order_id: 'ઓર્ડર આઈડી',
        receiver_notregister: 'રીસીવર રજીસ્ટર થયેલ નથી'
    },
    kn: {
        gold: 'ಚಿನ್ನ',
        gems: "ಜೇಮ್ಸ್",
        locker: 'ಲಾಕರ್',
        buy: 'ಖರೀದಿಸಿ',
        buybuttontxt: 'ಖರೀದಿಸಿ ₹ {mintingcost}',
        sell: 'ಬೆಚೆ',
        confirm: 'ಖಚಿತಪಡಿಸಿ',
        cancel: 'ರದ್ದುಮಾಡಿ',
        goldlockerbalance: 'ಚಿನ್ನದ ಲಾಕರ್ ಬ್ಯಾಲೆನ್ಸ್',
        askedquestion: 'ಪದೇ ಪದೇ ಕೇಳಲಾಗುವ ಪ್ರಶ್ನೆಗಳು',
        recenttransaction: 'ಇತ್ತೀಚಿನ ವಹಿವಾಟು',
        choosegoldseller: 'ಚಿನ್ನ ಮಾರಾಟಗಾರನನ್ನು ಆರಿಸಿ',
        buyingrams: 'ಗ್ರಾಂನಲ್ಲಿ ಖರೀದಿಸಿ',
        buyinamount: 'ಮೊತ್ತದಲ್ಲಿ ಖರೀದಿಸಿ',
        sellinamount: 'ಮೊತ್ತದಲ್ಲಿ ಮಾರಾಟ ಮಾಡಿ',
        sellingrams: 'ಗ್ರಾಂನಲ್ಲಿ ಮಾರಲಾಗುತ್ತದೆ',
        successfulpayment: ' ಚಿನ್ನದ ಯಶಸ್ವಿ ಖರೀದಿ',
        unsuccessfulpayment: 'ನನಿಮ್ಮ ವಹಿವಾಟು ವಿಫಲವಾಗಿದೆ',
        selleragent: 'ಮಾರಾಟಗಾರ ಏಜೆಂಟ್',
        seelocker: 'ಲಾಕರ್ ನೋಡಿ',
        paymentreview: 'ಪಾವತಿ ವಿಮರ್ಶೆ',
        basedongoldprise: 'ಚಿನ್ನದ ಬೆಲೆಯ ಆಧಾರದ ಮೇಲೆ',
        boughtgold: 'ನೀವು ಖರೀದಿಸಿದ ಚಿನ್ನ',
        discount: 'ರಿಯಾಯಿತಿ',
        paywithdiscount: 'ರಿಯಾಯಿತಿಯೊಂದಿಗೆ ಪಾವತಿಸಿ',
        processingcharge: 'ಪ್ರಕ್ರಿಯೆ ಶುಲ್ಕ',
        pay: 'ನೀವು ಪಾವತಿಸುವಿರಿ',
        sellgold: 'ಚಿನ್ನವನ್ನು ಮಾರಾಟ ಮಾಡಿ',
        buygold: 'ಚಿನ್ನ ಖರೀದಿಸಿ',
        registration: 'ನೋಂದಣಿ',
        consumerdetail: 'ಗ್ರಾಹಕರ ವಿವರಗಳು',
        username: 'ಬಳಕೆದಾರ ಹೆಸರು',
        email: 'ಇಮೇಲ್',
        phone_no: 'ದೂರವಾಣಿ ಸಂಖ್ಯೆ',
        address: 'ವಿಳಾಸ',
        street: 'ರಸ್ತೆ',
        pincode: 'ಪಿನ್ ಕೋಡ್',
        city: 'ನಗರ',
        state: 'ರಾಜ್ಯ',
        aaddhar_no: 'ಆಧಾರ್ ಸಂಖ್ಯೆ',
        pan_number: 'ಪ್ಯಾನ್ ಸಂಖ್ಯೆ',
        account_name: 'ಬ್ಯಾಂಕ್ ಹೋಲ್ಡರ್ ಹೆಸರು',
        bankaccount: 'ಬ್ಯಾಂಕ್ ಖಾತೆ',
        re_bank_aacount: 'ಮರು ಬ್ಯಾಂಕ್ ಖಾತೆ',
        ifsc_code: 'ifsc ಕೋಡ್',
        bank: 'ಬ್ಯಾಂಕ್',
        submit: 'ಸಲ್ಲಿಸಿ',
        include_gst: '3% ಜಿಎಸ್ಟಿ ಸೇರಿಸಿ',
        enteramount: 'ಮೊತ್ತವನ್ನು ನಮೂದಿಸಿ',
        total_amount: 'ಒಟ್ಟು ಮೊತ್ತ',
        purity: 'ಶುದ್ಧತೆ',
        fill_username: 'ದಯವಿಟ್ಟು ಬಳಕೆದಾರರ ಹೆಸರನ್ನು ಭರ್ತಿ ಮಾಡಿ',
        fill_phoneno: 'ದಯವಿಟ್ಟು ಸರಿಯಾದ ಫೋನ್ ಸಂಖ್ಯೆಯನ್ನು ಭರ್ತಿ ಮಾಡಿ',
        fill_pincode: 'ದಯವಿಟ್ಟು ಸರಿಯಾದ ಪಿನ್‌ಕೋಡ್ ಅನ್ನು ಭರ್ತಿ ಮಾಡಿ',
        fill_city: 'ದಯವಿಟ್ಟು ಸರಿಯಾದ ನಗರವನ್ನು ಭರ್ತಿ ಮಾಡಿ',
        fill_aadhar: 'ದಯವಿಟ್ಟು ಸರಿಯಾದ ಆಧಾರ್ ಅನ್ನು ಭರ್ತಿ ಮಾಡಿ',
        fill_panno: 'ದಯವಿಟ್ಟು ಸರಿಯಾದ ಪ್ಯಾನ್ ಸಂಖ್ಯೆಯನ್ನು ಭರ್ತಿ ಮಾಡಿ',
        holder_name: 'ದಯವಿಟ್ಟು ಸರಿಯಾದ ಬ್ಯಾಂಕ್ ಖಾತೆದಾರರ ಹೆಸರನ್ನು ಭರ್ತಿ ಮಾಡಿ',
        fill_bankaccount: 'ದಯವಿಟ್ಟು ಸರಿಯಾದ ಬ್ಯಾಂಕ್ ಖಾತೆಯನ್ನು ಭರ್ತಿ ಮಾಡಿ',
        fill_ifsccode: 'ದಯವಿಟ್ಟು ಸರಿಯಾದ ifsc ಕೋಡ್ ಅನ್ನು ಭರ್ತಿ ಮಾಡಿ',
        fill_upicode: 'ದಯವಿಟ್ಟು ಸರಿಯಾದ ಉಪ ಕೋಡ್ ಅನ್ನು ಭರ್ತಿ ಮಾಡಿ',
        termsandcondition: 'ದಯವಿಟ್ಟು ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳನ್ನು ಸ್ವೀಕರಿಸಿ',
        nohistoryfound: 'ಯಾವುದೇ ಇತಿಹಾಸ ಕಂಡುಬಂದಿಲ್ಲ',
        fillupto4decimal: 'ಶೂನ್ಯ ಮತ್ತು 10 ಗ್ರಾಂ ಗಿಂತ ಹೆಚ್ಚು ಇರಬಾರದು ಮತ್ತು ಕೇವಲ 4 ದಶಮಾಂಶ ಸ್ಥಳಗಳು ಮಾತ್ರ ಅನುಮತಿಸುತ್ತವೆ',
        fillamountupto2decimal: 'ಮೊತ್ತವು ರೂಪಾಯಿ 1 ಕ್ಕಿಂತ ಕಡಿಮೆಯಿರಬಾರದು ಅಥವಾ 10000 ರೂಪಾಯಿಗಳಿಗಿಂತ ಹೆಚ್ಚಿರಬಾರದು. 2 ದಶಮಾಂಶ ಸ್ಥಳಗಳವರೆಗೆ ಮಾತ್ರ ಅನುಮತಿಸಲಾಗಿದೆ.',
        somethingwentwrong: 'ಏನೋ ತಪ್ಪಾಗಿದೆ, ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ!',
        notauthorised: 'ನಿಮಗೆ ಅಧಿಕಾರವಿಲ್ಲ!',
        notregistered: 'ನೀವು ನೋಂದಾಯಿಸಲಾಗಿಲ್ಲ!',
        nompoint_sellandbuy: 'ನೀವು ಖರೀದಿಸದೆ ಮಾರಾಟ ಮಾಡಲು ಸಾಕಷ್ಟು ಎಂಪಾಯಿಂಟ್‌ಗಳನ್ನು ಹೊಂದಿಲ್ಲ!',
        successfullysoldgold: 'ನೀವು ಚಿನ್ನವನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಮಾರಾಟ ಮಾಡಿದ್ದೀರಿ. ನಿಮ್ಮ ಹಣವನ್ನು ನಿಮ್ಮ ಬ್ಯಾಂಕ್ ಖಾತೆಗೆ ವರ್ಗಾಯಿಸಲಾಗುತ್ತದೆ',
        enoughgoldtosell: 'ನಿಮ್ಮ ಬಳಿ ಮಾರಾಟ ಮಾಡಲು ಸಾಕಷ್ಟು ಚಿನ್ನವಿಲ್ಲ',
        enoughgold: 'ನಿಮ್ಮ ಬಳಿ ಸಾಕಷ್ಟು ಚಿನ್ನವಿಲ್ಲ',
        amountlessthanrs2: 'ಮೊತ್ತವು ರೂಪಾಯಿ 1 ಕ್ಕಿಂತ ಕಡಿಮೆಯಿರಬಾರದು. 2 ದಶಮಾಂಶ ಸ್ಥಳಗಳವರೆಗೆ ಮಾತ್ರ ಅನುಮತಿಸಲಾಗಿದೆ',
        amountcannotzero: 'ಮೊತ್ತ ಶೂನ್ಯವಾಗಿರಬಾರದು. 4 ದಶಮಾಂಶ ಸ್ಥಳಗಳವರೆಗೆ ಮಾತ್ರ ಅನುಮತಿಸಲಾಗಿದೆ',
        upicode: 'UPI ಕೋಡ್',
        lessthan1: '1 ರೂಪಾಯಿಗಿಂತ ಕಡಿಮೆ ಖರೀದಿಸಲು ಸಾಧ್ಯವಿಲ್ಲ',
        time: 'ಉಳಿದ ಸಮಯ',
        gram: 'ಗ್ರಾಮ',
        wallet: 'ಕೈಚೀಲ ',
        transferdescription: 'ಮೊತ್ತ ವರ್ಗಾವಣೆ ವಿವರಣೆ',
        refundinbank: 'ಬ್ಯಾಂಕಿನಲ್ಲಿ ಮರುಪಾವತಿ',
        refundinwallet: 'ಕೈಚೀಲದಲ್ಲಿ ಮರುಪಾವತಿ',
        confirmbankaccount: 'ಬ್ಯಾಂಕ್ ಖಾತೆ ಸಂಖ್ಯೆ ಹೊಂದಿಕೆಯಾಗುವುದಿಲ್ಲ ಎಂದು ಖಚಿತಪಡಿಸಿ',
        delivery: 'ವಿತರಣೆ',
        deliver_gold: 'ಈಗ ನಿಮ್ಮ 24 ಕೆ ಚಿನ್ನದ ಸಮತೋಲನವನ್ನು ನಿಮ್ಮ ಚಿನ್ನದ ನಾಣ್ಯಗಳ ರೂಪದಲ್ಲಿ ನಿಮ್ಮ ಮನೆ ಬಾಗಿಲಿಗೆ ತಲುಪಿಸಿ.',
        howitwork: 'ಇದು ಹೇಗೆ ಕಾರ್ಯನಿರ್ವಹಿಸುತ್ತದೆ',
        sellerproceed: 'ಪ್ರಕ್ರಿಯೆಗೆ ಮಾರಾಟಗಾರನನ್ನು ಆಯ್ಕೆಮಾಡಿ',
        choosegoldcoin: 'ಚಿನ್ನದ ನಾಣ್ಯವನ್ನು ಆರಿಸಿ',
        paymakingcharges: 'ಪಾವತಿಸುವ ಶುಲ್ಕಗಳು',
        gethomedelivery: 'ಮನೆ ವಿತರಣೆಯನ್ನು ಪಡೆಯಿರಿ',
        constructionfee: 'ನಿರ್ಮಾಣ ಶುಲ್ಕ',
        freeshipping: 'ಉಚಿತ ಸಾಗಾಟ',
        address_delivery: 'ನಿಮ್ಮ ವಿಳಾಸ ವಿತರಣೆ',
        available_purchasebalance: 'ನಿಮ್ಮ ಚಿನ್ನದ ಬಾಕಿ ಖರೀದಿ ಬಾಕಿಗಿಂತ ಕಡಿಮೆಯಾಗಿದೆ. ಮೊದಲು ಚಿನ್ನ ಖರೀದಿಸಿ.',
        product_details: 'ಉತ್ಪನ್ನ_ ವಿವರಗಳು',
        add_newaddress: 'ಹೊಸ ವಿಳಾಸವನ್ನು ಸೇರಿಸಿ',
        specify_deliveryaddress: 'ವಿತರಣಾ ವಿಳಾಸವನ್ನು ನಿರ್ದಿಷ್ಟಪಡಿಸಿ',
        fullname: 'ಪೂರ್ಣ ಹೆಸರು',
        pincode: 'ಪಿನ್ ಕೋಡ್',
        house_no: 'ಮನೆಯ ಸಂಖ್ಯೆ',
        mobile_no: 'ಮೊಬೈಲ್ ಸಂಖ್ಯೆ',
        digit_mobile_no: '10 ಅಂಕೆಗಳೊಂದಿಗೆ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ',
        landmark: 'ಹೆಗ್ಗುರುತು',
        landmark_location: 'ಹತ್ತಿರದ / ಪ್ರಸಿದ್ಧ ಸ್ಥಳ',
        save_address: 'ವಿಳಾಸವನ್ನು ಉಳಿಸಿ',
        gold_balance: 'ಚಿನ್ನದ ಸಮತೋಲನ',
        return_policy: 'ಹಿಂತಿರುಗಿಸುವ ಕಾರ್ಯನೀತಿ',
        fill_fullname: 'ದಯವಿಟ್ಟು ಪೂರ್ಣ ಹೆಸರನ್ನು ಭರ್ತಿ ಮಾಡಿ',
        fill_state: 'ದಯವಿಟ್ಟು ರಾಜ್ಯವನ್ನು ಭರ್ತಿ ಮಾಡಿ',
        fill_houseno: 'ದಯವಿಟ್ಟು ಸರಿಯಾದ ಮನೆ ಸಂಖ್ಯೆಯನ್ನು ಭರ್ತಿ ಮಾಡಿ',
        fill_mobileno: 'ದಯವಿಟ್ಟು ಸರಿಯಾದ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು ಭರ್ತಿ ಮಾಡಿ',
        fill_street: 'ದಯವಿಟ್ಟು ಸರಿಯಾದ ಬೀದಿಯಲ್ಲಿ ಭರ್ತಿ ಮಾಡಿ',
        fill_landmark: 'ದಯವಿಟ್ಟು ಸರಿಯಾದ ಹೆಗ್ಗುರುತನ್ನು ಭರ್ತಿ ಮಾಡಿ',
        product: 'ಉತ್ಪನ್ನ',
        new_address: '+ ಹೊಸ ವಿಳಾಸವನ್ನು ಸೇರಿಸಿ',
        return_policydescription: 'ಯಾವುದೇ ರಿಟರ್ನ್ / ರಿಪ್ಲೇಸ್ಮೆಂಟ್ ಅನ್ನು ಅನುಮತಿಸಲಾಗುವುದಿಲ್ಲ - ಈ ಉತ್ಪನ್ನಕ್ಕಾಗಿ ಮಾರಾಟಗಾರರಿಂದ ರಿಟರ್ನ್ಸ್ ಅಥವಾ ರಿಪ್ಲೇಸ್ಮೆಂಟ್ಗಳನ್ನು ಸ್ವೀಕರಿಸಲಾಗುವುದಿಲ್ಲ. ರದ್ದತಿಗೆ ಅನುಮತಿ ಇಲ್ಲ - ಒಮ್ಮೆ ಆದೇಶಿಸಿದ ನಂತರ ಈ ಉತ್ಪನ್ನಕ್ಕೆ ರದ್ದತಿಯನ್ನು ಅನುಮತಿಸಲಾಗುವುದಿಲ್ಲ.',
        product_descrp1: 'ನೀವು ಸಾಕಷ್ಟು ಡಿಜಿಟಲ್ ಚಿನ್ನದ ಸಮತೋಲನವನ್ನು ಹೊಂದಿದ್ದರೆ ಮಾತ್ರ ದಯವಿಟ್ಟು ಈ ಉತ್ಪನ್ನವನ್ನು ಆಯ್ಕೆ ಮಾಡಿ. ಸಾಕಷ್ಟು ಚಿನ್ನದ ಬಾಕಿ ಇದ್ದರೆ, ಈ ಆದೇಶವನ್ನು ತಿರಸ್ಕರಿಸಲಾಗುತ್ತದೆ',
        product_descrp2: 'ಪ್ರತಿಯೊಂದು ನಾಣ್ಯವನ್ನು ಸಹಿ ಮಾಡಿದ, ಸಂಖ್ಯೆಯ ರಕ್ಷಣಾತ್ಮಕ ಪ್ರಮಾಣಪತ್ರ ಪ್ಯಾಕೇಜಿಂಗ್‌ನಲ್ಲಿ ಮುಚ್ಚಲಾಗುತ್ತದೆ, ಅದು ಲೋಹದ ವಿಷಯ, ತೂಕ ಮತ್ತು ಗುಣಮಟ್ಟವನ್ನು ಖಾತರಿಪಡಿಸುತ್ತದೆ.',
        product_descrp3: 'ಆಧುನಿಕ, ಅತ್ಯಾಧುನಿಕ ಸಂಸ್ಕರಣಾಗಾರದಲ್ಲಿ ಅತ್ಯಧಿಕ ಸ್ವಿಸ್ ಎಂಜಿನಿಯರಿಂಗ್ ಕೌಶಲ್ಯಗಳನ್ನು ಬಳಸಿಕೊಂಡು ನಾಣ್ಯವನ್ನು ನಿರ್ಮಿಸಲಾಗಿದೆ. ಚಿನ್ನ ಮತ್ತು ಬೆಳ್ಳಿಯ ಜಾಗತಿಕ ಮಾನದಂಡವಾದ ಎಲ್‌ಬಿಎಂಎ (ಲಂಡನ್ ಬುಲಿಯನ್ ಮಾರ್ಕೆಟ್ ಅಸೋಸಿಯೇಷನ್) ಮಾನ್ಯತೆ ಪಡೆದ ಭಾರತದ ಏಕೈಕ ಸಂಸ್ಕರಣಾಗಾರವೆಂದರೆ ಸೇಫ್-ಗೋಲ್ಡ್.',
        product_descrp4: 'ಆ ದಿನ 100% ಚಿನ್ನದ ಬೆಲೆಯಲ್ಲಿ ಬಿಲ್ ಉತ್ಪಾದನೆಯ ಮೇಲೆ ಸುರಕ್ಷಿತ-ಗೋಲ್ಡ್ ಅಂಗಡಿಯಲ್ಲಿ ಸುಲಭ ಮರುಖರೀದಿ ಲಭ್ಯವಿದೆ.',
        delivery_date: 'ವಿತರಣಾ ದಿನಾಂಕ',
        refundpaytm: 'paytm ನಲ್ಲಿ ಮರುಪಾವತಿ',
        goldproduct: 'ಚಿನ್ನದ ಉತ್ಪನ್ನ',
        gift_lockerbalance: 'ನಿಮ್ಮ ಲಾಕರ್ ಬ್ಯಾಲೆನ್ಸ್',
        giftyourself: 'ನೀವೇ ಉಡುಗೊರೆಯಾಗಿ ನೀಡಿ',
        mobilenumber: 'ಮೊಬೈಲ್ ನಂಬರ',
        enteramountgold: 'ಮೊತ್ತದ ಚಿನ್ನವನ್ನು ರೂ.',
        message: 'ಸಂದೇಶ',
        gold_gifthere: 'ಇಲ್ಲಿ ನಿಮ್ಮ ಚಿನ್ನದ ಉಡುಗೊರೆ',
        goldgift: 'ಉಡುಗೊರೆ ಚಿನ್ನ',
        gifthistory: 'ಉಡುಗೊರೆ ಇತಿಹಾಸ',
        myorders: 'ನನ್ನ ಆಜ್ಞೆಗಳು',
        note: 'ಟಿಪ್ಪಣಿ',
        transactionid: 'ವಹಿವಾಟು ಐಡಿ',
        invoiceid: 'ಸರಕುಪಟ್ಟಿ ಐಡಿ',
        sinceamountlessthan: 'ನಿಮ್ಮ ಮೊತ್ತವು 50 ಕ್ಕಿಂತ ಕಡಿಮೆಯಿರುವುದರಿಂದ',
        amountshow: 'ಮೊತ್ತ',
        transferredpaytmwallet: 'ಅನ್ನು ನಿಮ್ಮ ಪೇಟಿಎಂ ವ್ಯಾಲೆಟ್‌ಗೆ ವರ್ಗಾಯಿಸಲಾಗುತ್ತದೆ',
        gift: 'ಉಡುಗೊರೆ',
        entervalid_mobileno: 'ಮಾನ್ಯವಾದ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ',
        enter_goldamount: 'ಚಿನ್ನದ ಮೊತ್ತವನ್ನು ನಮೂದಿಸಿ',
        enough_gold: 'ನಿಮ್ಮ ಬಳಿ ಸಾಕಷ್ಟು ಚಿನ್ನವಿಲ್ಲ',
        successfully_giftedgold: 'ನೀವು ಯಶಸ್ವಿಯಾಗಿ ಚಿನ್ನವನ್ನು ಉಡುಗೊರೆಯಾಗಿ ನೀಡಿದ್ದೀರಿ',
        no_history: 'ಯಾವುದೇ ಇತಿಹಾಸ ಲಭ್ಯವಿಲ್ಲ',
        trackorder: 'ಟ್ರ್ಯಾಕ್ ಆದೇಶ',
        deliveryestimate: 'ವಿತರಣಾ ಅಂದಾಜು:',
        order_id: 'ಆರ್ಡರ್ ಐಡಿ',
        receiver_notregister: 'ಸ್ವೀಕರಿಸುವವರನ್ನು ನೋಂದಾಯಿಸಲಾಗಿಲ್ಲ'
    },
    ml: {
        gold: 'സ്വർണം',
        gems: "ജെയിംസ്",
        locker: 'ലോക്കർ',
        buy: 'വാങ്ങുക',
        buybuttontxt: 'വാങ്ങുക ₹ {mintingcost}',
        sell: 'വാങ്ങുക',
        confirm: 'സ്ഥിരീകരിക്കുക',
        cancel: 'റദ്ദാക്കുക',
        goldlockerbalance: 'ഗോൾഡ് ലോക്കർ ബാലൻസ്',
        askedquestion: 'ഒരു തരത്തിൽ',
        recenttransaction: 'ഏറ്റവും പുതിയ ഇടപാട്',
        choosegoldseller: 'സ്വർണ്ണ വിൽപ്പനക്കാരനെ തിരഞ്ഞെടുക്കുക',
        buyingrams: 'ഗ്രാമിൽ വാങ്ങുക',
        buyinamount: 'തുകയിൽ വാങ്ങുക',
        sellingrams: 'ഗ്രാമിൽ വിറ്റു',
        sellinamount: 'തുക വിൽക്കുക',
        successfulpayment: 'സ്വർണം വിജയകരമായി വാങ്ങി',
        unsuccessfulpayment: 'നിങ്ങളുടെ ഇടപാട് പരാജയപ്പെട്ടു',
        selleragent: 'വിൽപ്പന ഏജന്റ്',
        seelocker: 'ലോക്കർ കാണുക',
        paymentreview: 'പേയ്‌മെന്റ് അവലോകനം',
        basedongoldprise: 'സ്വർണ്ണ വില അടിസ്ഥാനമാക്കി',
        boughtgold: 'നിങ്ങൾ വാങ്ങിയ സ്വർണം',
        discount: 'കിഴിവ്',
        paywithdiscount: 'കിഴിവോടെ പണമടയ്‌ക്കുക',
        processingcharge: 'പ്രോസസ്സിംഗ് ചാർജ്',
        pay: 'നിങ്ങൾ പണമടയ്ക്കും',
        sellgold: 'സ്വർണം വിൽക്കുക',
        buygold: 'സ്വർണം വാങ്ങുക',
        registration: 'രജിസ്ട്രേഷൻ',
        consumerdetail: 'ഉപഭോക്തൃ വിശദാംശങ്ങൾ',
        username: 'ഉപയോക്തൃ നാമം',
        email: 'ഇമെയിൽ',
        phone_no: 'ഫോൺ നമ്പർ',
        address: 'വിലാസം',
        street: 'തെരുവ്',
        pincode: 'പിൻ കോഡ്',
        city: 'നഗരം',
        state: 'സംസ്ഥാനം',
        aaddhar_no: 'ആധാർ നമ്പർ',
        pan_number: 'പാൻ നമ്പർ',
        account_name: 'ബാങ്ക് ഉടമയുടെ പേര്',
        bankaccount: 'ബാങ്ക് അക്കൗണ്ട്',
        re_bank_aacount: 'വീണ്ടും ബാങ്ക് അക്കൗണ്ട്',
        ifsc_code: 'ifsc കോഡ്',
        bank: 'ബാങ്ക്',
        submit: 'സമർപ്പിക്കുക',
        include_gst: '3% ജിഎസ്ടി ഉൾപ്പെടുത്തുക',
        enteramount: 'തുക നൽകുക',
        total_amount: 'ആകെ തുക',
        purity: 'പരിശുദ്ധി',
        fill_username: 'ഉപയോക്തൃനാമം പൂരിപ്പിക്കുക',
        fill_phoneno: 'ശരിയായ ഫോൺ നമ്പർ പൂരിപ്പിക്കുക',
        fill_pincode: 'ശരിയായ പിൻ‌കോഡ് പൂരിപ്പിക്കുക',
        fill_city: 'ശരിയായ നഗരം പൂരിപ്പിക്കുക',
        fill_aadhar: 'ശരിയായ ആധാർ പൂരിപ്പിക്കുക',
        fill_panno: 'ശരിയായ പാൻ നമ്പർ പൂരിപ്പിക്കുക',
        holder_name: 'ശരിയായ ബാങ്ക് അക്ക hold ണ്ട് ഉടമയുടെ പേര് പൂരിപ്പിക്കുക',
        fill_bankaccount: 'ശരിയായ ബാങ്ക് അക്കൗണ്ട് പൂരിപ്പിക്കുക',
        fill_ifsccode: 'ശരിയായ ifsc കോഡ് പൂരിപ്പിക്കുക',
        fill_upicode: 'ശരിയായ ഉപ കോഡ് പൂരിപ്പിക്കുക',
        termsandcondition: 'നിബന്ധനകളും വ്യവസ്ഥകളും അംഗീകരിക്കുക',
        nohistoryfound: 'ചരിത്രമൊന്നും കണ്ടെത്തിയില്ല',
        fillupto4decimal: 'പൂജ്യമാകാനും 10 ഗ്രാമിൽ കൂടുതൽ ആകാനും കഴിയില്ല, കൂടാതെ 4 ദശാംശസ്ഥാനങ്ങൾ മാത്രമേ അനുവദിക്കൂ',
        fillamountupto2decimal: 'തുക 1 രൂപയിൽ കുറവോ 10000 രൂപയിൽ കൂടുതലോ ആകരുത്. 2 ദശാംശസ്ഥാനങ്ങൾ വരെ മാത്രം അനുവദനീയമാണ്.',
        somethingwentwrong: 'എന്തോ കുഴപ്പം സംഭവിച്ചു, വീണ്ടും ശ്രമിക്കുക!',
        notauthorised: 'നിങ്ങൾക്ക് അംഗീകാരമില്ല!',
        notregistered: 'നിങ്ങൾ രജിസ്റ്റർ ചെയ്തിട്ടില്ല!',
        nompoint_sellandbuy: 'വാങ്ങാതെ വിൽക്കാൻ നിങ്ങൾക്ക് മതിയായ എംപോയിന്റുകൾ ഇല്ല!',
        successfullysoldgold: 'നിങ്ങൾ വിജയകരമായി സ്വർണം വിറ്റു. നിങ്ങളുടെ പണം നിങ്ങളുടെ ബാങ്ക് അക്ക to ണ്ടിലേക്ക് മാറ്റപ്പെടും',
        enoughgoldtosell: 'നിങ്ങൾക്ക് വിൽക്കാൻ ആവശ്യമായ സ്വർണം ഇല്ല',
        enoughgold: 'നിങ്ങൾക്ക് ആവശ്യത്തിന് സ്വർണം ഇല്ല',
        amountlessthanrs2: 'തുക രൂപ 1 ൽ താഴെയാകരുത്. 2 ദശാംശസ്ഥാനങ്ങൾ വരെ മാത്രം അനുവദനീയമാണ്',
        amountcannotzero: 'തുക പൂജ്യമാകരുത്. 4 ദശാംശസ്ഥാനങ്ങൾ വരെ മാത്രം അനുവദിച്ചിരിക്കുന്നു',
        upicode: 'UPI കോഡ്',
        lessthan1: 'ഒരു രൂപയിൽ താഴെ വാങ്ങാൻ കഴിയില്ല',
        time: 'ശേഷിക്കുന്ന സമയം',
        gram: 'ഗ്രാമം',
        wallet: 'വാലറ്റ് ',
        transferdescription: 'തുക കൈമാറ്റം വിവരണം',
        refundinbank: 'ബാങ്കിൽ റീഫണ്ട്',
        refundinwallet: 'വാലറ്റിൽ റീഫണ്ട്',
        confirmbankaccount: 'ബാങ്ക് അക്കൗണ്ട് നമ്പർ പൊരുത്തപ്പെടുന്നില്ലെന്ന് സ്ഥിരീകരിക്കുക',
        delivery: 'ഡെലിവറി',
        deliver_gold: 'ഇപ്പോൾ നിങ്ങളുടെ 24k സ്വർണ്ണ ബാലൻസ് നിങ്ങളുടെ സ്വർണ്ണ നാണയങ്ങളുടെ രൂപത്തിൽ നിങ്ങളുടെ വാതിൽക്കൽ എത്തിക്കുക.',
        howitwork: 'ഇത് എങ്ങനെ പ്രവർത്തിക്കുന്നു',
        sellerproceed: 'പ്രോസസ്സ് ചെയ്യുന്നതിന് വിൽപ്പനക്കാരനെ തിരഞ്ഞെടുക്കുക',
        choosegoldcoin: 'സ്വർണ്ണ നാണയം തിരഞ്ഞെടുക്കുക',
        paymakingcharges: 'പണമടയ്ക്കൽ നിരക്കുകൾ',
        gethomedelivery: 'ഹോം ഡെലിവറി നേടുക',
        constructionfee: 'നിർമ്മാണ ഫീസ്',
        freeshipping: 'ഫ്രീ ഷിപ്പിംഗ്',
        address_delivery: 'നിങ്ങളുടെ വിലാസ ഡെലിവറി',
        available_purchasebalance: 'നിങ്ങളുടെ സ്വർണ്ണ ബാലൻസ് വാങ്ങൽ ബാലൻസിനേക്കാൾ കുറവാണ്. ആദ്യം സ്വർണം വാങ്ങുക.',
        product_details: 'ഉൽപ്പന്നത്തിന്റെ വിവരം',
        add_newaddress: 'പുതിയ വിലാസം ചേർക്കുക',
        specify_deliveryaddress: 'ഡെലിവറി വിലാസം വ്യക്തമാക്കുക',
        fullname: 'മുഴുവൻ പേര്',
        pincode: 'പിൻ കോഡ്',
        house_no: 'വീട്ടു നമ്പർ',
        mobile_no: 'മൊബൈൽ നമ്പർ',
        digit_mobile_no: '10 അക്കങ്ങളുള്ള മൊബൈൽ നമ്പർ',
        landmark: 'ലാൻഡ്മാർക്ക്',
        landmark_location: 'സമീപം / പ്രസിദ്ധമായ സ്ഥാനം',
        save_address: 'വിലാസം സംരക്ഷിക്കുക',
        gold_balance: 'സ്വർണ്ണ ബാലൻസ്',
        return_policy: 'തിരികെ നൽകൽ നയം',
        fill_fullname: 'മുഴുവൻ പേരും പൂരിപ്പിക്കുക',
        fill_state: 'സംസ്ഥാനം പൂരിപ്പിക്കുക',
        fill_houseno: 'ശരിയായ വീട്ടു നമ്പർ പൂരിപ്പിക്കുക',
        fill_mobileno: 'ശരിയായ മൊബൈൽ‌ നമ്പർ‌ പൂരിപ്പിക്കുക',
        fill_street: 'ശരിയായ തെരുവിൽ പൂരിപ്പിക്കുക',
        fill_landmark: 'ശരിയായ ലാൻഡ്മാർക്ക് പൂരിപ്പിക്കുക',
        product: 'ഉൽപ്പന്നം',
        new_address: '+ പുതിയ വിലാസം ചേർക്കുക',
        return_policydescription: 'റിട്ടേൺ / മാറ്റിസ്ഥാപിക്കൽ അനുവദനീയമല്ല - ഈ ഉൽ‌പ്പന്നത്തിനായി വിൽ‌പ്പനക്കാരൻ റിട്ടേണുകൾ‌ അല്ലെങ്കിൽ‌ മാറ്റിസ്ഥാപിക്കൽ‌ സ്വീകരിക്കുന്നില്ല. റദ്ദാക്കൽ‌ അനുവദനീയമല്ല - ഓർ‌ഡർ‌ ചെയ്‌തുകഴിഞ്ഞാൽ‌ ഈ ഉൽ‌പ്പന്നത്തിന് റദ്ദാക്കൽ‌ അനുവദനീയമല്ല.',
        product_descrp1: 'നിങ്ങൾക്ക് മതിയായ ഡിജിറ്റൽ ഗോൾഡ് ബാലൻസ് ഉണ്ടെങ്കിൽ മാത്രം ഈ ഉൽപ്പന്നം തിരഞ്ഞെടുക്കുക. സ്വർണ്ണ ബാലൻസ് അപര്യാപ്തമാണെങ്കിൽ, ഈ ഓർഡർ നിരസിക്കപ്പെടും',
        product_descrp2: 'ഓരോ നാണയവും ഒപ്പിട്ട, അക്കമിട്ട സംരക്ഷണ സർട്ടിഫിക്കറ്റ് പാക്കേജിംഗിൽ അടച്ചിരിക്കുന്നു, അത് ലോഹത്തിന്റെ ഉള്ളടക്കം, ഭാരം, ഗുണമേന്മ എന്നിവ ഉറപ്പ് നൽകുന്നു.',
        product_descrp3: 'ആധുനികവും അത്യാധുനികവുമായ ഒരു റിഫൈനറിയിലെ ഏറ്റവും ഉയർന്ന സ്വിസ് എഞ്ചിനീയറിംഗ് കഴിവുകൾ ഉപയോഗിച്ചാണ് നാണയം നിർമ്മിച്ചിരിക്കുന്നത്. സ്വർണ്ണത്തിന്റെയും വെള്ളിയുടെയും ആഗോള നിലവാരമായ എൽ‌ബി‌എം‌എ (ലണ്ടൻ ബുള്ളിയൻ മാർക്കറ്റ് അസോസിയേഷൻ) അംഗീകരിച്ച ഇന്ത്യയിലെ ഏക റിഫൈനറിയാണ് സേഫ്-ഗോൾഡ്.',
        product_descrp4: 'അന്ന് 100% സ്വർണ്ണ വിലയ്ക്ക് ബിൽ ഉത്പാദിപ്പിക്കുന്നതിന് സേഫ്-ഗോൾഡ് സ്റ്റോറിൽ എളുപ്പത്തിൽ തിരിച്ചുവാങ്ങൽ ലഭ്യമാണ്.',
        delivery_date: 'ഡെലിവറി തീയതി',
        refundpaytm: 'പേടിഎമ്മിൽ റീഫണ്ട്',
        goldproduct: 'സ്വർണ്ണ ഉൽപ്പന്നം',
        gift_lockerbalance: 'നിങ്ങളുടെ ലോക്കർ ബാലൻസ്',
        giftyourself: 'സ്വയം സമ്മാനം നൽകുക',
        mobilenumber: 'മൊബൈൽ നമ്പർ',
        enteramountgold: 'രൂപ സ്വർണം നൽകുക.',
        message: 'സന്ദേശം',
        gold_gifthere: 'ഇവിടെ നിങ്ങളുടെ സ്വർണ്ണ സമ്മാനം',
        goldgift: 'സ്വർണം സമ്മാനിക്കുക',
        gifthistory: 'സമ്മാന ചരിത്രം',
        myorders: 'എന്റെ ഓർഡറുകൾ',
        note: 'കുറിപ്പ്',
        transactionid: 'ഇടപാട് ഐഡി',
        invoiceid: 'ഇൻവോയ്സ് ഐഡി',
        sinceamountlessthan: 'നിങ്ങളുടെ തുക 50-ൽ കുറവായതിനാൽ',
        amountshow: 'തുക',
        transferredpaytmwallet: 'പേടിഎം വാലറ്റിലേക്ക് മാറ്റപ്പെടും',
        gift: 'സമ്മാനം',
        entervalid_mobileno: 'സാധുവായ ഒരു മൊബൈൽ നമ്പർ നൽകുക',
        enter_goldamount: 'സ്വർണ്ണ തുക നൽകുക',
        enough_gold: 'നിങ്ങൾക്ക് ആവശ്യത്തിന് സ്വർണം ഇല്ല',
        successfully_giftedgold: 'നിങ്ങൾ വിജയകരമായി സ്വർണം സമ്മാനിച്ചു',
        no_history: 'ചരിത്രമൊന്നും ലഭ്യമല്ല',
        trackorder: 'ട്രാക്ക് ഓർഡർ',
        deliveryestimate: 'ഡെലിവറി എസ്റ്റിമേറ്റ്:',
        order_id: 'ഓർഡർ ഐഡി',
        receiver_notregister: 'സ്വീകർത്താവ് രജിസ്റ്റർ ചെയ്തിട്ടില്ല'
    },
    mr: {
        gold: 'सोने',
        gems: "जेम्स",
        locker: 'लॉकर',
        buy: 'खरेदी करा',
        buybuttontxt: 'खरेदी करा ₹ {mintingcost}',
        sell: 'बेचे',
        confirm: 'पुष्टी',
        cancel: 'रद्द करा',
        goldlockerbalance: 'गोल्ड लॉकर शिल्लक',
        askedquestion: 'वारंवार विचारले जाणारे प्रश्न',
        recenttransaction: 'अलीकडील व्यवहार',
        choosegoldseller: 'सोने विक्रेता निवडा',
        buyingrams: 'ग्रॅम मध्ये खरेदी करा',
        buyinamount: 'रक्कम खरेदी करा',
        sellingrams: 'हरभरा मध्ये विकले जाते',
        sellinamount: 'रक्कम विक्री',
        successfulpayment: 'यशस्वी सोन्याची खरेदी',
        unsuccessfulpayment: 'आपला व्यवहार अयशस्वी झाला',
        selleragent: 'विक्रेता एजंट',
        seelocker: 'लॉकर पहा',
        paymentreview: 'देय पुनरावलोकन',
        basedongoldprise: 'सोन्याच्या किंमतीवर आधारित',
        boughtgold: 'आपले खरेदी केलेले सोने',
        discount: 'सवलत',
        paywithdiscount: 'सूट देऊन पैसे द्या',
        processingcharge: 'प्रक्रिया शुल्क',
        pay: 'आपण देय द्याल',
        sellgold: 'सोन्याची विक्री करा',
        buygold: 'सोने खरेदी करा',
        registration: 'नोंदणी',
        consumerdetail: 'ग्राहक तपशील',
        username: 'वापरकर्त्याचे नाव',
        email: 'ईमेल',
        phone_no: 'दूरध्वनी क्रमांक',
        address: 'पत्ता',
        street: 'रस्ता',
        pincode: 'पिन कोड',
        city: 'शहर',
        state: 'राज्य',
        aaddhar_no: 'आधार क्रमांक',
        pan_number: 'पॅन नंबर',
        account_name: 'बँक धारकाचे नाव',
        bankaccount: 'बँक खाते',
        re_bank_aacount: 'पुन्हा बँक खाते',
        ifsc_code: 'ifsc कोड',
        bank: 'बँक',
        submit: 'सबमिट करा',
        include_gst: '3% जीएसटीचा समावेश करा',
        enteramount: 'रक्कम प्रविष्ट करा',
        total_amount: 'एकूण रक्कम',
        purity: 'पवित्रता',
        fill_username: 'कृपया वापरकर्त्याचे नाव भरा',
        fill_phoneno: 'कृपया योग्य फोन नंबर भरा',
        fill_pincode: 'कृपया योग्य पिनकोड भरा',
        fill_city: 'कृपया योग्य शहर भरा',
        fill_aadhar: 'कृपया योग्य आधार भरा',
        fill_panno: 'कृपया योग्य पॅन क्रमांक भरा',
        holder_name: 'कृपया अचूक बँक खातेधारकाचे नाव भरा',
        fill_bankaccount: 'कृपया अचूक बँक खाते भरा',
        fill_ifsccode: 'कृपया योग्य ifsc कोड भरा',
        fill_upicode: 'कृपया योग्य अपी कोड भरा',
        termsandcondition: 'कृपया अटी व शर्ती मान्य करा',
        nohistoryfound: 'कोणताही इतिहास सापडला नाही',
        fillupto4decimal: 'शून्य आणि 10 ग्रॅमपेक्षा जास्त असू शकत नाही आणि केवळ 4 दशांश ठिकाणे अनुमती देतात',
        fillamountupto2decimal: 'रक्कम 1 रुपयांपेक्षा कमी किंवा 10000 रुपयांपेक्षा जास्त असू शकत नाही. केवळ 2 दशांश ठिकाणी परवानगी आहे.',
        somethingwentwrong: 'काहीतरी चूक झाली, पुन्हा प्रयत्न करा!',
        notauthorised: 'आपण अधिकृत नाही!',
        notregistered: 'आपण नोंदणीकृत नाही!',
        nompoint_sellandbuy: 'आपल्याकडे खरेदी केल्याशिवाय विक्रीवर पुरेसे Gems नाहीत!',
        successfullysoldgold: 'आपण यशस्वीरित्या सोने विकले आहे. आपले पैसे आपल्या बँक खात्यात हस्तांतरित केले जातील',
        enoughgoldtosell: 'आपल्याकडे विकायला पुरेसे सोने नाही',
        enoughgold: 'आपल्याकडे पुरेसे सोने नाही',
        amountlessthanrs2: 'रक्कम १ रुपयांपेक्षा कमी असू शकत नाही. फक्त २ दशांश ठिकाणी परवानगी आहे',
        amountcannotzero: 'रक्कम शून्य असू शकत नाही. केवळ 4 दशांश ठिकाणी परवानगी आहे',
        upicode: 'UPI कोड',
        lessthan1: '1 रुपयांपेक्षा कमी खरेदी करू शकत नाही',
        time: 'शिल्लक वेळ',
        gram: 'गाव',
        wallet: 'पाकीट ',
        transferdescription: 'रक्कम हस्तांतरण वर्णन',
        refundinbank: 'बँकेत पैसे परत करा',
        refundinwallet: 'पाकीट मध्ये पैसे परत',
        confirmbankaccount: 'बँक खाते क्रमांक जुळत नाही याची पुष्टी करा',
        delivery: 'वितरण',
        deliver_gold: 'आता आपल्या सोन्याच्या नाण्यांच्या रुपात आपल्या 24 के सोन्याचे शिल्लक वितरित करा.',
        howitwork: 'ते कसे कार्य करते',
        sellerproceed: 'पुढे जाण्यासाठी विक्रेता निवडा',
        choosegoldcoin: 'सोन्याचे नाणे निवडा',
        paymakingcharges: 'देय शुल्क',
        gethomedelivery: 'होम डिलिव्हरी मिळवा',
        constructionfee: 'बांधकाम शुल्क',
        freeshipping: 'विनामूल्य शिपिंग',
        address_delivery: 'आपली पत्ता वितरण',
        available_purchasebalance: 'आपले सोन्याचे शिल्लक खरेदी शिल्लकपेक्षा कमी आहे. कृपया आधी सोने खरेदी करा.',
        product_details: 'उत्पादन वितरण',
        add_newaddress: 'नवीन पत्ता जोडा',
        specify_deliveryaddress: 'वितरण पत्ता निर्दिष्ट करा',
        fullname: 'पूर्ण नाव',
        pincode: 'पिन कोड',
        house_no: 'घर क्रमांक',
        mobile_no: 'मोबाइल नंबर',
        digit_mobile_no: '10 अंकांसह मोबाइल नंबर',
        landmark: 'लँडमार्क',
        landmark_location: 'जवळपास / प्रसिद्ध स्थान',
        save_address: 'पत्ता जतन करा',
        gold_balance: 'सोन्याचे संतुलन',
        return_policy: 'रिटर्न पॉलिसी',
        fill_fullname: 'कृपया पूर्ण नाव भरा',
        fill_state: 'कृपया राज्य भरा',
        fill_houseno: 'कृपया योग्य घर क्रमांक भरा',
        fill_mobileno: 'कृपया योग्य मोबाइल नंबर भरा',
        fill_street: 'कृपया योग्य रस्ता भरा',
        fill_landmark: 'कृपया अचूक खूण भरा',
        product: 'उत्पादन',
        new_address: '+ नवीन पत्ता जोडा',
        return_policydescription: 'रिटर्न / रिप्लेसमेंटला परवानगी नाही - या उत्पादकासाठी विक्रेत्याद्वारे परतावा किंवा बदलण्याची शक्यता स्वीकारली जात नाही. रद्द करण्याची परवानगी नाही - एकदा ऑर्डर केल्यावर या उत्पादनासाठी रद्द करण्याची परवानगी नाही.',
        product_descrp1: 'कृपया आपल्याकडे पुरेसे डिजिटल सोन्याचे शिल्लक असल्यासच हे उत्पादन निवडा. अपुरा सोन्याची शिल्लक असल्यास ही मागणी नाकारली जाईल',
        product_descrp2: 'प्रत्येक नाणे स्वाक्षरी केलेल्या, क्रमांकित संरक्षणात्मक प्रमाणपत्र पॅकेजिंगमध्ये बंद केले गेले आहे जे धातूची सामग्री, वजन आणि गुणवत्तेची हमी देते.',
        product_descrp3: 'आधुनिक, अत्याधुनिक रिफायनरीमधील सर्वोच्च स्विस अभियांत्रिकी कौशल्याचा वापर करून हे नाणे तयार केले गेले आहे. सेफ-गोल्ड ही भारतातील एकमेव रिफायनरी आहे जी एलबीएमए (लंडन बुलियन मार्केट असोसिएशन) द्वारे मान्यता प्राप्त आहे, जे सोने आणि चांदीचे जागतिक मानक आहे.',
        product_descrp4: 'त्या दिवशी 100% सोन्याच्या किंमतीवर बिलाच्या उत्पादनावर सेफ-गोल्ड स्टोअरमध्ये सोपा बायबॅक उपलब्ध आहे.',
        delivery_date: 'वितरण तारीख',
        refundpaytm: 'पेटीएममध्ये परतावा',
        goldproduct: 'सोन्याचे उत्पादन',
        gift_lockerbalance: 'आपले लॉकर शिल्लक',
        giftyourself: 'स्वत: ला भेट द्या',
        mobilenumber: 'मोबाइल नंबर',
        enteramountgold: 'रुपये रक्कम गोल्ड प्रविष्ट करा.',
        message: 'संदेश',
        gold_gifthere: 'येथे आपली सुवर्ण भेट',
        goldgift: 'भेट सोने',
        gifthistory: 'भेट इतिहास',
        myorders: 'माझे आदेश',
        note: 'चिठ्ठी',
        transactionid: 'व्यवहार आयडी',
        invoiceid: 'बीजक आयडी',
        sinceamountlessthan: 'आपली रक्कम 50 पेक्षा कमी असल्याने',
        amountshow: 'रक्कम',
        transferredpaytmwallet: 'आपल्या पेटीएम वॉलेटमध्ये हस्तांतरित केले जाईल',
        gift: 'भेट',
        entervalid_mobileno: 'एक वैध मोबाइल नंबर प्रविष्ट करा',
        enter_goldamount: 'सोन्याची रक्कम प्रविष्ट करा',
        enough_gold: 'आपल्याकडे पुरेसे सोने नाही',
        successfully_giftedgold: 'आपण यशस्वीरित्या सोने भेट दिले',
        no_history: 'इतिहास उपलब्ध नाही',
        trackorder: 'ट्रॅक ऑर्डर',
        deliveryestimate: 'अंदाजे पोच:',
        order_id: 'ऑर्डर आयडी',
        receiver_notregister: 'प्राप्तकर्ता नोंदणीकृत नाही'
    },
    ta: {
        gold: 'தங்கம்',
        locker: 'லாக்கர்',
        buy: 'வாங்கப்பட்டது',
        buybuttontxt: 'வாங்கப்பட்டது ₹ {mintingcost}',
        sell: 'விற்க',
        confirm: 'உறுதிப்படுத்த',
        cancel: 'ரத்து',
        goldlockerbalance: 'தங்க லாக்கர் இருப்பு',
        askedquestion: 'அடிக்கடி கேட்கப்படும் கேள்விகள்',
        recenttransaction: 'சமீபத்திய பரிவர்த்தனை',
        choosegoldseller: 'தங்க விற்பனையாளரைத் தேர்வுசெய்க',
        buyingrams: 'கிராம் வாங்க',
        buyinamount: 'தொகையில் வாங்கவும்',
        sellinamount: 'அளவு விற்க',
        sellingrams: 'கிராம் விற்கப்படுகிறது',
        successfulpayment: 'தங்கத்தை வெற்றிகரமாக வாங்குவது',
        unsuccessfulpayment: 'உங்கள் பரிவர்த்தனை தோல்வியுற்றது',
        selleragent: 'விற்பனையாளர் முகவர்',
        seelocker: 'லாக்கரைக் காண்க',
        paymentreview: 'கட்டண மதிப்பாய்வு',
        basedongoldprise: 'தங்க விலையின் அடிப்படையில்',
        boughtgold: 'நீங்கள் வாங்கிய தங்கம்',
        discount: 'தள்ளுபடி',
        paywithdiscount: 'தள்ளுபடியுடன் செலுத்துங்கள்',
        processingcharge: 'செயலாக்க கட்டணம்',
        pay: 'நீங்கள் பணம் செலுத்துவீர்கள்',
        sellgold: 'தங்கத்தை விற்கவும்',
        buygold: 'தங்கம் வாங்க',
        registration: 'பதிவு',
        consumerdetail: 'நுகர்வோர் விவரங்கள்',
        username: 'பயனர் பெயர்',
        email: 'மின்னஞ்சல்',
        phone_no: 'தொலைபேசி எண்',
        address: 'முகவரி',
        street: 'தெரு',
        pincode: 'அஞ்சல் குறியீடு',
        city: 'నగరం',
        state: 'நிலை',
        aaddhar_no: 'ஆதார் எண்',
        pan_number: 'பான் எண்',
        account_name: 'வங்கி வைத்திருப்பவரின் பெயர்',
        bankaccount: 'வங்கி கணக்கு',
        re_bank_aacount: 'மறு வங்கி கணக்கு',
        ifsc_code: 'ifsc குறியீடு',
        bank: 'வங்கி',
        submit: 'சமர்ப்பி',
        include_gst: '3% ஜிஎஸ்டி சேர்க்கவும்',
        enteramount: 'தொகையை உள்ளிடவும்',
        total_amount: 'மொத்த தொகை',
        purity: 'தூய்மை',
        fill_username: 'பயனர் பெயரை நிரப்பவும்',
        fill_phoneno: 'சரியான தொலைபேசி எண்ணை நிரப்பவும்',
        fill_pincode: 'சரியான பின்கோடை நிரப்பவும்',
        fill_city: 'சரியான நகரத்தை நிரப்பவும்',
        fill_aadhar: 'சரியான ஆதாரை நிரப்பவும்',
        fill_panno: 'சரியான பான் எண்ணை நிரப்பவும்',
        holder_name: 'சரியான வங்கி கணக்கு வைத்திருப்பவரின் பெயரை நிரப்பவும்',
        fill_bankaccount: 'சரியான வங்கிக் கணக்கை நிரப்பவும்',
        fill_ifsccode: 'சரியான ifsc குறியீட்டை நிரப்பவும்',
        fill_upicode: 'சரியான உபி குறியீட்டை நிரப்பவும்',
        termsandcondition: 'விதிமுறைகளையும் நிபந்தனைகளையும் ஏற்கவும்',
        nohistoryfound: 'ചരിത്രമൊന്നും കണ്ടെത്തിയില്ല',
        fillupto4decimal: 'பூஜ்ஜியமாகவும் 10 கிராமுக்கு மேல் இருக்கவும் முடியாது, மேலும் 4 தசம இடங்கள் மட்டுமே அனுமதிக்கின்றன',
        fillamountupto2decimal: 'தொகை ரூபாய் 1 ஐ விட குறைவாகவோ அல்லது 10000 ரூபாயை விட அதிகமாகவோ இருக்கக்கூடாது. 2 தசம இடங்கள் வரை மட்டுமே அனுமதிக்கப்படுகிறது.',
        somethingwentwrong: 'ஏதோ தவறு ஏற்பட்டது, மீண்டும் முயற்சிக்கவும்!',
        notauthorised: 'உங்களுக்கு அங்கீகாரம் இல்லை!',
        notregistered: 'நீங்கள் பதிவு செய்யப்படவில்லை!',
        nompoint_sellandbuy: 'வாங்காமல் விற்க போதுமான Gems கள் உங்களிடம் இல்லை!',
        successfullysoldgold: 'நீங்கள் வெற்றிகரமாக தங்கத்தை விற்றுவிட்டீர்கள். உங்கள் பணம் உங்கள் வங்கிக் கணக்கிற்கு மாற்றப்படும்',
        enoughgoldtosell: 'உங்களிடம் விற்க போதுமான தங்கம் இல்லை',
        enoughgold: 'உங்களிடம் போதுமான தங்கம் இல்லை',
        amountlessthanrs2: 'தொகை ரூபாயை விட குறைவாக இருக்கக்கூடாது 1. 2 தசம இடங்கள் வரை மட்டுமே அனுமதிக்கப்படுகிறது',
        amountcannotzero: 'தொகை பூஜ்ஜியமாக இருக்க முடியாது. 4 தசம இடங்கள் வரை மட்டுமே அனுமதிக்கப்படுகிறது',
        upicode: 'UPI குறியீடு',
        lessthan1: '1 ரூபாய்க்கும் குறைவாக வாங்க முடியாது',
        time: 'மீதியுள்ள நேரம்',
        gram: 'கிராமம்',
        wallet: 'கைப்பை ',
        transferdescription: 'அளவு பரிமாற்ற விளக்கம்',
        refundinbank: 'வங்கியில் பணத்தைத் திரும்பப் பெறுங்கள்',
        refundinwallet: 'பணப்பையில் பணத்தைத் திரும்பப் பெறுங்கள்',
        confirmbankaccount: 'வங்கி கணக்கு எண் பொருந்தவில்லை என்பதை உறுதிப்படுத்தவும்',
        delivery: 'டெலிவரி',
        deliver_gold: 'இப்போது உங்கள் 24k தங்க இருப்பை உங்கள் தங்க நாணயங்களின் வடிவத்தில் உங்கள் வீட்டு வாசலுக்கு வழங்குங்கள்.',
        howitwork: 'அது எவ்வாறு இயங்குகிறது',
        sellerproceed: 'செயலாக்க விற்பனையாளரைத் தேர்ந்தெடுக்கவும்',
        choosegoldcoin: 'தங்க நாணயத்தைத் தேர்வுசெய்க',
        paymakingcharges: 'கட்டணம் செலுத்தும் கட்டணம்',
        gethomedelivery: 'வீட்டு விநியோகத்தைப் பெறுங்கள்',
        constructionfee: 'கட்டுமான கட்டணம்',
        freeshipping: 'இலவச கப்பல் போக்குவரத்து',
        address_delivery: 'உங்கள் முகவரி வழங்கல்',
        available_purchasebalance: 'உங்கள் தங்க இருப்பு கொள்முதல் நிலுவை விட குறைவாக உள்ளது. முதலில் தங்கத்தை வாங்கவும்.',
        product_details: 'தயாரிப்பு விவரங்கள்',
        add_newaddress: 'புதிய முகவரியைச் சேர்க்கவும்',
        specify_deliveryaddress: 'விநியோக முகவரியைக் குறிப்பிடவும்',
        fullname: 'முழு பெயர்',
        pincode: 'ஜிப் குறியீடு',
        house_no: 'வீட்டின் எண்',
        mobile_no: 'மொபைல் எண்',
        digit_mobile_no: '10 இலக்கங்களுடன் மொபைல் எண்',
        landmark: 'தனித்துவமான',
        landmark_location: 'அருகிலுள்ள / பிரபலமான இடம்',
        save_address: 'முகவரியைச் சேமிக்கவும்',
        gold_balance: 'தங்க இருப்பு',
        return_policy: 'திரும்பும் கொள்கை',
        fill_fullname: 'முழு பெயரையும் நிரப்பவும்',
        fill_state: 'மாநிலத்தை நிரப்பவும்',
        fill_houseno: 'சரியான வீட்டு எண்ணை நிரப்பவும்',
        fill_mobileno: 'சரியான மொபைல் எண்ணை நிரப்பவும்',
        fill_street: 'சரியான தெருவை நிரப்பவும்',
        fill_landmark: 'சரியான அடையாளத்தை நிரப்பவும்',
        product: 'தயாரிப்பு',
        new_address: '+ புதிய முகவரியைச் சேர்க்கவும்',
        return_policydescription: 'திரும்ப / மாற்றீடு அனுமதிக்கப்படவில்லை - இந்த தயாரிப்புக்கான விற்பனையாளரால் வருமானம் அல்லது மாற்றீடுகள் ஏற்கப்படவில்லை. ரத்து செய்ய அனுமதிக்கப்படவில்லை - ஆர்டர் செய்தவுடன் இந்த தயாரிப்புக்கு ரத்து செய்ய அனுமதிக்கப்படாது.',
        product_descrp1: 'உங்களிடம் போதுமான டிஜிட்டல் தங்க இருப்பு இருந்தால் மட்டுமே இந்த தயாரிப்பைத் தேர்ந்தெடுக்கவும். போதுமான தங்க இருப்பு இல்லாவிட்டால், இந்த உத்தரவு நிராகரிக்கப்படும்',
        product_descrp2: 'ஒவ்வொரு நாணயமும் கையொப்பமிடப்பட்ட, எண்ணிடப்பட்ட பாதுகாப்பு சான்றிதழ் பேக்கேஜிங்கில் மூடப்பட்டிருக்கும், இது உலோக உள்ளடக்கம், எடை மற்றும் தரம் ஆகியவற்றை உறுதி செய்கிறது.',
        product_descrp3: 'நவீன, அதிநவீன சுத்திகரிப்பு நிலையத்தில் மிக உயர்ந்த சுவிஸ் பொறியியல் திறன்களைப் பயன்படுத்தி இந்த நாணயம் கட்டப்பட்டுள்ளது. தங்கம் மற்றும் வெள்ளிக்கான உலகளாவிய தரமான எல்.பி.எம்.ஏ (லண்டன் புல்லியன் சந்தை சங்கம்) அங்கீகரித்த இந்தியாவில் உள்ள ஒரே சுத்திகரிப்பு நிலையம் சேஃப்-கோல்ட் ஆகும்.',
        product_descrp4: 'அன்றைய தினம் 100% தங்க விலையில் பில் தயாரிப்பில் SAFE-GOLD கடையில் எளிதாக வாங்குதல் கிடைக்கும்.',
        delivery_date: 'விநியோக தேதி',
        refundpaytm: 'paytm இல் பணத்தைத் திரும்பப் பெறுங்கள்',
        goldproduct: 'தங்க தயாரிப்பு',
        gift_lockerbalance: 'உங்கள் லாக்கர் இருப்பு',
        giftyourself: 'நீங்களே பரிசளிக்கவும்',
        mobilenumber: 'மொபைல் எண்',
        enteramountgold: 'தொகை தங்கத்தை ரூ.',
        message: 'செய்தி',
        gold_gifthere: 'இங்கே உங்கள் தங்க பரிசு',
        goldgift: 'பரிசு தங்கம்',
        gifthistory: 'பரிசு வரலாறு',
        myorders: 'என் கட்டளைகள்',
        note: 'குறிப்பு',
        transactionid: 'பரிவர்த்தனை ஐடி',
        invoiceid: 'விலைப்பட்டியல் ஐடி',
        sinceamountlessthan: 'உங்கள் தொகை 50 க்கும் குறைவாக இருப்பதால்',
        amountshow: 'அளவு',
        transferredpaytmwallet: 'உங்கள் Paytm Wallet க்கு மாற்றப்படும்',
        gift: 'பரிசு',
        entervalid_mobileno: 'செல்லுபடியாகும் மொபைல் எண்ணை உள்ளிடவும்',
        enter_goldamount: 'தங்கத் தொகையை உள்ளிடவும்',
        enough_gold: 'உங்களிடம் போதுமான தங்கம் இல்லை',
        successfully_giftedgold: 'நீங்கள் வெற்றிகரமாக தங்கத்தை பரிசாக வழங்கியுள்ளீர்கள்',
        no_history: 'வரலாறு கிடைக்கவில்லை',
        trackorder: 'பாதையில் பொருட்டு',
        deliveryestimate: 'விநியோக மதிப்பீடு:',
        order_id: 'ஆர்டர் ஐடி',
        receiver_notregister: 'பெறுநர் பதிவு செய்யப்படவில்லை'
    },
    te: {
        gold: 'బంగారం',
        gems: "జేమ్స్",
        locker: 'లాకర్',
        buy: 'కొనుగోలు',
        buybuttontxt: 'కొనుగోలు ₹ {mintingcost}',
        sell: 'అమ్మకపు',
        confirm: 'నిర్ధారించండి',
        cancel: 'రద్దు చేయండి',
        goldlockerbalance: 'గోల్డ్ లాకర్ బ్యాలెన్స్',
        askedquestion: 'తరచుగా అడిగే ప్రశ్నలు',
        recenttransaction: 'ఇటీవలి లావాదేవీ',
        choosegoldseller: 'బంగారు విక్రేతను ఎంచుకోండి',
        buyingrams: 'గ్రాములలో కొనండి',
        buyinamount: 'మొత్తంలో కొనండి',
        sellingrams: 'గ్రాములలో అమ్ముతారు',
        sellinamount: 'మొత్తంలో అమ్మండి',
        successfulpayment: 'బంగారం విజయవంతంగా కొనుగోలు',
        unsuccessfulpayment: 'మీ లావాదేవీ విజయవంతం కాలేదు',
        selleragent: 'విక్రేత ఏజెంట్',
        seelocker: 'ਡਿਲਿਵਰੀలాకర్ చూడండి',
        paymentreview: 'చెల్లింపు సమీక్ష',
        basedongoldprise: 'బంగారం ధర ఆధారంగా',
        boughtgold: ' మీరు కొన్న బంగారం',
        discount: 'డిస్కౌంట్',
        paywithdiscount: 'తగ్గింపుతో చెల్లించండి',
        processingcharge: 'ప్రాసెసింగ్ ఛార్జ్',
        pay: 'మీరు చెల్లిస్తారు',
        sellgold: 'బంగారం అమ్మండి',
        buygold: 'బంగారం కొనండి',
        registration: 'నమోదు',
        consumerdetail: 'వినియోగదారుల వివరాలు',
        username: 'వినియోగదారు పేరు',
        email: 'ఇమెయిల్',
        phone_no: 'చరవాణి సంఖ్య',
        address: 'చిరునామా',
        street: 'వీధి',
        pincode: 'పిన్ కోడ్',
        city: 'நகரம்',
        state: 'రాష్ట్రం',
        aaddhar_no: 'ఆధార్ సంఖ్య',
        pan_number: 'పాన్ సంఖ్య',
        account_name: 'బ్యాంక్ హోల్డర్ పేరు',
        bankaccount: 'బ్యాంకు ఖాతా',
        re_bank_aacount: 'తిరిగి బ్యాంక్ ఖాతా',
        ifsc_code: 'ifsc కోడ్',
        bank: 'బ్యాంక్',
        submit: 'సమర్పించండి',
        include_gst: '3% జీఎస్టీని చేర్చండి',
        enteramount: 'మొత్తాన్ని నమోదు చేయండి',
        total_amount: 'మొత్తం మొత్తం',
        purity: 'స్వచ్ఛత',
        fill_username: 'దయచేసి వినియోగదారు పేరు నింపండి',
        fill_phoneno: 'దయచేసి సరైన ఫోన్ నంబర్‌ను పూరించండి',
        fill_pincode: 'దయచేసి సరైన పిన్‌కోడ్‌ను పూరించండి',
        fill_city: 'దయచేసి సరైన నగరాన్ని పూరించండి',
        fill_aadhar: 'దయచేసి సరైన ఆధార్ నింపండి',
        fill_panno: 'దయచేసి సరైన పాన్ నంబర్ నింపండి',
        holder_name: 'దయచేసి సరైన బ్యాంక్ ఖాతాదారు పేరు నింపండి',
        fill_bankaccount: 'దయచేసి సరైన బ్యాంక్ ఖాతాను పూరించండి',
        fill_ifsccode: 'దయచేసి సరైన ifsc కోడ్‌ను పూరించండి',
        fill_upicode: 'దయచేసి సరైన ఉప కోడ్‌ను పూరించండి',
        termsandcondition: 'దయచేసి నిబంధనలు మరియు షరతులను అంగీకరించండి',
        nohistoryfound: 'చరిత్ర కనుగొనబడలేదు',
        fillupto4decimal: 'సున్నా మరియు 10 గ్రాముల కంటే ఎక్కువ ఉండకూడదు మరియు 4 దశాంశ స్థానాలు మాత్రమే అనుమతిస్తాయి',
        fillamountupto2decimal: 'మొత్తం రూపాయి 1 కంటే తక్కువ లేదా 10000 రూపాయల కంటే ఎక్కువ ఉండకూడదు. 2 దశాంశ స్థానాల వరకు మాత్రమే అనుమతించబడుతుంది.',
        somethingwentwrong: 'ఏదో తప్పు జరిగింది, మళ్ళీ ప్రయత్నించండి!',
        notauthorised: 'మీకు అధికారం లేదు!',
        notregistered: 'మీరు నమోదు కాలేదు!',
        nompoint_sellandbuy: 'కొనుగోలు చేయకుండా విక్రయించడానికి మీకు తగినంత ఎంపాయింట్లు లేవు!',
        successfullysoldgold: 'మీరు విజయవంతంగా బంగారాన్ని అమ్మారు. మీ డబ్బు మీ బ్యాంక్ ఖాతాకు బదిలీ చేయబడుతుంది',
        enoughgoldtosell: 'మీకు అమ్మడానికి తగినంత బంగారం లేదు',
        enoughgold: 'మీకు తగినంత బంగారం లేదు',
        amountlessthanrs2: 'మొత్తం రూపాయి 1 కన్నా తక్కువ ఉండకూడదు. 2 దశాంశ స్థానాల వరకు మాత్రమే అనుమతించబడుతుంది',
        amountcannotzero: 'మొత్తం సున్నా కాదు. 4 దశాంశ స్థానాల వరకు మాత్రమే అనుమతించబడుతుంది',
        upicode: 'UPI కోడ్',
        lessthan1: '1 రూపాయి కన్నా తక్కువ కొనలేరు',
        time: 'మిగిలిన సమయం',
        gram: 'విలేజ్',
        wallet: 'జేబు ',
        transferdescription: 'మొత్తం బదిలీ వివరణ',
        refundinbank: 'బ్యాంకులో డబ్బు తిరిగి పొందండి',
        refundinwallet: 'వాలెట్‌లో వాపసు',
        confirmbankaccount: 'బ్యాంక్ ఖాతా సంఖ్య సరిపోలలేదని నిర్ధారించండి',
        delivery: 'డెలివరీ',
        deliver_gold: 'ఇప్పుడు మీ 24 కే బంగారు బ్యాలెన్స్‌ను మీ బంగారు నాణేల రూపంలో మీ తలుపుకు పంపించండి.',
        howitwork: 'ఇది ఎలా పనిచేస్తుంది',
        sellerproceed: 'ప్రాసెస్ చేయడానికి విక్రేతను ఎంచుకోండి',
        choosegoldcoin: 'బంగారు నాణెం ఎంచుకోండి',
        paymakingcharges: 'చెల్లింపు ఛార్జీలు',
        gethomedelivery: 'హోమ్ డెలివరీ పొందండి',
        constructionfee: 'నిర్మాణ రుసుము',
        freeshipping: 'ఉచిత షిప్పింగ్',
        address_delivery: 'మీ చిరునామా డెలివరీ',
        available_purchasebalance: 'మీ బంగారు బ్యాలెన్స్ కొనుగోలు బ్యాలెన్స్ కంటే తక్కువ. ముందుగా బంగారం కొనండి.',
        product_details: 'వస్తువు యొక్క వివరాలు',
        add_newaddress: 'క్రొత్త చిరునామాను జోడించండి',
        specify_deliveryaddress: 'డెలివరీ చిరునామాను పేర్కొనండి',
        fullname: 'పూర్తి పేరు',
        pincode: 'పిన్ కోడ్',
        house_no: 'ఇంటి సంఖ్య',
        mobile_no: 'మొబైల్ సంఖ్య',
        digit_mobile_no: '10 అంకెల మొబైల్ నంబర్ ',
        landmark: 'ల్యాండ్మార్క్',
        landmark_location: 'సమీప / ప్రసిద్ధ స్థానం',
        save_address: 'చిరునామాను సేవ్ చేయండి',
        gold_balance: 'బంగారు బ్యాలెన్స్',
        return_policy: 'రిటర్న్ విధానం',
        fill_fullname: 'దయచేసి పూర్తి పేరు నింపండి',
        fill_state: 'దయచేసి రాష్ట్రంలో నింపండి',
        fill_houseno: 'దయచేసి సరైన ఇంటి సంఖ్యను పూరించండి',
        fill_mobileno: 'దయచేసి సరైన మొబైల్ నంబర్‌ను పూరించండి',
        fill_street: 'దయచేసి సరైన వీధిలో నింపండి',
        fill_landmark: 'దయచేసి సరైన మైలురాయిని పూరించండి',
        product: 'ఉత్పత్తి',
        new_address: '+ క్రొత్త చిరునామాను జోడించండి',
        return_policydescription: 'రిటర్న్ / పున lace స్థాపన అనుమతించబడదు - ఈ ఉత్పత్తి కోసం అమ్మకందారుడు రిటర్న్స్ లేదా పున lace స్థాపనలను అంగీకరించరు. రద్దు చేయడానికి అనుమతి లేదు - ఒకసారి ఆదేశించిన తర్వాత ఈ ఉత్పత్తికి రద్దు అనుమతించబడదు.',
        product_descrp1: 'మీకు తగినంత డిజిటల్ బంగారు బ్యాలెన్స్ ఉంటే మాత్రమే ఈ ఉత్పత్తిని ఎంచుకోండి. తగినంత బంగారు బ్యాలెన్స్ లేకపోతే, ఈ ఆర్డర్ తిరస్కరించబడుతుంది',
        product_descrp2: 'ప్రతి నాణెం మెటల్ కంటెంట్, బరువు మరియు నాణ్యతకు హామీ ఇచ్చే సంతకం చేసిన, సంఖ్యా రక్షిత సర్టిఫికేట్ ప్యాకేజింగ్‌లో మూసివేయబడుతుంది.',
        product_descrp3: 'ఆధునిక, అత్యాధునిక శుద్ధి కర్మాగారంలో అత్యధిక స్విస్ ఇంజనీరింగ్ నైపుణ్యాలను ఉపయోగించి ఈ నాణెం నిర్మించబడింది. బంగారం మరియు వెండి ప్రపంచ ప్రమాణమైన ఎల్‌బిఎంఎ (లండన్ బులియన్ మార్కెట్ అసోసియేషన్) చేత గుర్తించబడిన భారతదేశంలో సేఫ్-గోల్డ్ మాత్రమే రిఫైనరీ.',
        product_descrp4: 'ఆ రోజు 100% బంగారు ధర వద్ద బిల్లు ఉత్పత్తిపై సేఫ్-గోల్డ్ స్టోర్‌లో సులభంగా తిరిగి పొందవచ్చు.',
        delivery_date: 'డెలివరీ తేదీ',
        refundpaytm: 'paytm లో వాపసు',
        goldproduct: 'బంగారు ఉత్పత్తి',
        gift_lockerbalance: 'మీ లాకర్ బ్యాలెన్స్',
        giftyourself: 'మీరే బహుమతిగా ఇవ్వండి',
        mobilenumber: 'మొబైల్ సంఖ్య',
        enteramountgold: 'మొత్తం బంగారాన్ని రూ.',
        message: 'సందేశం',
        gold_gifthere: 'ఇక్కడ మీ బంగారు బహుమతి',
        goldgift: 'బహుమతి బంగారం',
        gifthistory: 'బహుమతి చరిత్ర',
        myorders: 'నా ఆదేశాలు',
        note: 'గమనిక',
        transactionid: 'లావాదేవి ఐడి',
        invoiceid: 'ఇన్వాయిస్ ఐడి',
        sinceamountlessthan: 'కాబట్టి, మీ మొత్తం 50 కన్నా తక్కువ',
        amountshow: 'మొత్తం',
        transferredpaytmwallet: 'మీ Paytm వాలెట్‌కు బదిలీ చేయబడుతుంది',
        gift: 'బహుమతి',
        entervalid_mobileno: 'చెల్లుబాటు అయ్యే మొబైల్ నంబర్‌ను నమోదు చేయండి',
        enter_goldamount: 'బంగారు మొత్తాన్ని నమోదు చేయండి',
        enough_gold: 'మీకు తగినంత బంగారం లేదు',
        successfully_giftedgold: 'మీరు విజయవంతంగా బంగారాన్ని బహుమతిగా ఇచ్చారు',
        no_history: 'చరిత్ర అందుబాటులో లేదు',
        trackorder: 'ట్రాక్ ఆర్డర్',
        deliveryestimate: 'డెలివరీ అంచనా:',
        order_id: 'ఆర్డర్ గుర్తింపు సంఖ్యా',
        receiver_notregister: 'స్వీకర్త నమోదు చేయబడలేదు'
    },
    pa: {
        gold: 'ਸੋਨਾ',
        gems: "ਜੇਮਜ਼",
        locker: 'ਲਾਕਰ',
        buy: 'ਖਰੀਦੋ',
        buybuttontxt: 'ਖਰੀਦੋ ₹ {mintingcost}',
        sell: 'ਬੀਚੇ',
        confirm: 'ਪੁਸ਼ਟੀ ਕਰੋ',
        cancel: 'ਰੱਦ ਕਰੋ',
        goldlockerbalance: 'ਗੋਲਡ ਲਾਕਰ ਬੈਲੇਂਸ',
        askedquestion: 'ਅਕਸਰ ਪੁੱਛੇ ਜਾਂਦੇ ਪ੍ਰਸ਼ਨ',
        recenttransaction: 'ਤਾਜ਼ਾ ਲੈਣ-ਦੇਣ',
        choosegoldseller: 'ਸੋਨੇ ਦਾ ਵਿਕਰੇਤਾ ਚੁਣੋ',
        buyingrams: 'ਗ੍ਰਾਮ ਵਿਚ ਖਰੀਦੋ',
        buyinamount: 'ਰਕਮ ਵਿਚ ਖਰੀਦੋ',
        sellingrams: 'ਗ੍ਰਾਮ ਵਿਚ ਵੇਚਿਆ',
        sellinamount: 'ਰਕਮ ਵਿੱਚ ਵੇਚਣ',
        successfulpayment: 'ਸੋਨੇ ਦੀ ਸਫਲਤਾਪੂਰਵਕ ਖਰੀਦ',
        unsuccessfulpayment: 'ਤੁਹਾਡਾ ਲੈਣ-ਦੇਣ ਅਸਫਲ ਰਿਹਾ',
        selleragent: 'ਵਿਕਰੇਤਾ ਤਨਖਾਹ',
        seelocker: 'ਲਾਕਰ ਦੇਖੋ',
        paymentreview: 'ਭੁਗਤਾਨ ਸਮੀਖਿਆ',
        basedongoldprise: 'ਸੋਨੇ ਦੀ ਕੀਮਤ ਤੇ ਅਧਾਰਤ',
        boughtgold: 'ਤੁਹਾਡਾ ਖਰੀਦਿਆ ਸੋਨਾ',
        discount: 'ਛੂਟ',
        paywithdiscount: 'ਛੂਟ ਦੇ ਨਾਲ ਭੁਗਤਾਨ ਕਰੋ',
        processingcharge: 'ਪ੍ਰੋਸੈਸਿੰਗ ਚਾਰਜ',
        pay: 'ਭੁਗਤਾਨ ਕਰੋ',
        sellgold: 'ਸੋਨਾ ਵੇਚੋ',
        buygold: 'ਸੋਨਾ ਵੇਚੋ',
        registration: 'ਰਜਿਸਟ੍ਰੇਸ਼ਨ',
        consumerdetail: 'ਖਪਤਕਾਰਾਂ ਦਾ ਵੇਰਵਾ',
        username: 'ਉਪਭੋਗਤਾ ਨਾਮ',
        email: 'ਈ - ਮੇਲ',
        phone_no: 'ਫੋਨ ਨੰ',
        address: 'ਪਤਾ',
        street: 'ਗਲੀ',
        pincode: 'ਪਿੰਨ ਕੋਡ',
        city: 'ਸ਼ਹਿਰ',
        state: 'ਰਾਜ',
        aaddhar_no: 'ਆਧਾਰ ਨੰਬਰ',
        pan_number: 'ਪੈਨ ਨੰਬਰ',
        account_name: 'ਬੈਂਕ ਧਾਰਕ ਦਾ ਨਾਮ',
        bankaccount: 'ਬੈੰਕ ਖਾਤਾ',
        re_bank_aacount: 'ਬੈਂਕ ਖਾਤਾ ਮੁੜ',
        ifsc_code: 'ifsc ਕੋਡ',
        bank: 'ਬੈਂਕ',
        submit: 'ਜਮ੍ਹਾ ਕਰੋ',
        include_gst: '3% ਜੀਐਸਟੀ ਸ਼ਾਮਲ ਕਰੋ',
        enteramount: 'ਰਕਮ ਦਾਖਲ ਕਰੋ',
        total_amount: 'ਕੁੱਲ ਰਕਮ',
        purity: 'ਸ਼ੁੱਧਤਾ',
        fill_username: 'ਕਿਰਪਾ ਕਰਕੇ ਉਪਭੋਗਤਾ ਦਾ ਨਾਮ ਭਰੋ',
        fill_phoneno: 'ਕਿਰਪਾ ਕਰਕੇ ਸਹੀ ਫੋਨ ਨੰਬਰ ਭਰੋ',
        fill_pincode: 'ਕਿਰਪਾ ਕਰਕੇ ਸਹੀ ਪਿੰਨਕੋਡ ਭਰੋ',
        fill_city: 'ਕਿਰਪਾ ਕਰਕੇ ਸਹੀ ਸ਼ਹਿਰ ਭਰੋ',
        fill_aadhar: 'ਕਿਰਪਾ ਕਰਕੇ ਸਹੀ ਅਧਾਰ ਭਰੋ',
        fill_panno: 'ਕਿਰਪਾ ਕਰਕੇ ਸਹੀ ਪੈਨ ਨੰਬਰ ਭਰੋ',
        holder_name: 'ਕਿਰਪਾ ਕਰਕੇ ਸਹੀ ਬੈਂਕ ਖਾਤਾ ਧਾਰਕ ਦਾ ਨਾਮ ਭਰੋ',
        fill_bankaccount: 'ਕਿਰਪਾ ਕਰਕੇ ਸਹੀ ਬੈਂਕ ਖਾਤਾ ਭਰੋ',
        fill_ifsccode: 'ਕਿਰਪਾ ਕਰਕੇ ਸਹੀ ifsc ਕੋਡ ਭਰੋ',
        fill_upicode: 'ਕਿਰਪਾ ਕਰਕੇ ਸਹੀ ਉਪਰੀ ਕੋਡ ਭਰੋ',
        termsandcondition: 'ਕਿਰਪਾ ਕਰਕੇ ਨਿਯਮ ਅਤੇ ਸ਼ਰਤਾਂ ਨੂੰ ਸਵੀਕਾਰ ਕਰੋ',
        nohistoryfound: 'ਕੋਈ ਇਤਿਹਾਸ ਨਹੀਂ ਮਿਲਿਆ',
        fillupto4decimal: 'ਜ਼ੀਰੋ ਅਤੇ 10 ਗ੍ਰਾਮ ਤੋਂ ਵੱਧ ਨਹੀਂ ਹੋ ਸਕਦਾ ਅਤੇ ਸਿਰਫ 4 ਦਸ਼ਮਲਵ ਦੀ ਆਗਿਆ ਹੈ',
        fillamountupto2decimal: 'ਰਕਮ 1 ਰੁਪਏ ਜਾਂ 10000 ਰੁਪਏ ਤੋਂ ਘੱਟ ਨਹੀਂ ਹੋ ਸਕਦੀ. ਸਿਰਫ 2 ਦਸ਼ਮਲਵ ਸਥਾਨਾਂ ਤੱਕ ਹੀ ਆਗਿਆ ਹੈ.',
        somethingwentwrong: 'ਕੁਝ ਗਲਤ ਹੋ ਗਿਆ, ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ!',
        notauthorised: 'ਤੁਸੀਂ ਅਧਿਕਾਰਤ ਨਹੀਂ ਹੋ!',
        notregistered: 'ਤੁਸੀਂ ਰਜਿਸਟਰਡ ਨਹੀਂ ਹੋ!',
        nompoint_sellandbuy: 'ਤੁਹਾਡੇ ਕੋਲ ਖਰੀਦਣ ਬਗੈਰ ਵੇਚਣ ਲਈ ਲੋੜੀਂਦੇ ਸੰਸਦ ਨਹੀਂ ਹਨ!',
        successfullysoldgold: 'ਤੁਸੀਂ ਸਫਲਤਾਪੂਰਕ ਸੋਨਾ ਵੇਚ ਦਿੱਤਾ ਹੈ. ਤੁਹਾਡਾ ਪੈਸਾ ਤੁਹਾਡੇ ਬੈਂਕ ਖਾਤੇ ਵਿੱਚ ਟ੍ਰਾਂਸਫਰ ਹੋ ਜਾਵੇਗਾ',
        enoughgoldtosell: 'ਤੁਹਾਡੇ ਕੋਲ ਵੇਚਣ ਲਈ ਲੋੜੀਂਦਾ ਸੋਨਾ ਨਹੀਂ ਹੈ',
        enoughgold: 'ਤੁਹਾਡੇ ਕੋਲ ਇੰਨਾ ਸੋਨਾ ਨਹੀਂ ਹੈ',
        amountlessthanrs2: 'ਰਕਮ 1 ਰੁਪਏ ਤੋਂ ਘੱਟ ਨਹੀਂ ਹੋ ਸਕਦੀ. ਸਿਰਫ 2 ਦਸ਼ਮਲਵ ਸਥਾਨਾਂ ਤੱਕ ਆਗਿਆ ਹੈ',
        amountcannotzero: 'ਰਕਮ ਜ਼ੀਰੋ ਨਹੀਂ ਹੋ ਸਕਦੀ. ਸਿਰਫ 4 ਦਸ਼ਮਲਵ ਸਥਾਨਾਂ ਤੱਕ ਆਗਿਆ ਹੈ',
        upicode: 'UPI ਕੋਡ',
        lessthan1: '1 ਰੁਪਏ ਤੋਂ ਘੱਟ ਨਹੀਂ ਖਰੀਦ ਸਕਦੇ',
        time: 'ਬਾਕੀ ਸਮਾਂ',
        gram: 'ਪਿੰਡ',
        wallet: 'ਵਾਲਿਟ ',
        transferdescription: 'ਰਕਮ ਦਾ ਤਬਾਦਲਾ ਵੇਰਵਾ',
        refundinbank: 'ਬੈਂਕ ਵਿੱਚ ਰਿਫੰਡ',
        refundinwallet: 'ਵਾਲਿਟ ਵਿੱਚ ਰਿਫੰਡ',
        confirmbankaccount: 'ਪੁਸ਼ਟੀ ਕਰੋ ਕਿ ਬੈਂਕ ਖਾਤਾ ਨੰਬਰ ਮੇਲ ਨਹੀਂ ਖਾਂਦਾ',
        delivery: 'ਡਿਲਿਵਰੀ',
        deliver_gold: 'ਹੁਣ ਆਪਣੇ ਸੋਨੇ ਦੇ ਸਿੱਕਿਆਂ ਦੇ ਰੂਪ ਵਿਚ ਆਪਣੇ 24k ਸੋਨੇ ਦਾ ਸੰਤੁਲਨ ਆਪਣੇ ਦਰਵਾਜ਼ੇ ਤੇ ਪਹੁੰਚਾਓ.',
        howitwork: 'ਇਹ ਕਿਵੇਂ ਕੰਮ ਕਰਦਾ ਹੈ',
        sellerproceed: 'ਅੱਗੇ ਜਾਣ ਲਈ ਵਿਕਰੇਤਾ ਦੀ ਚੋਣ ਕਰੋ',
        choosegoldcoin: 'ਸੋਨੇ ਦਾ ਸਿੱਕਾ ਚੁਣੋ',
        paymakingcharges: 'ਤਨਖਾਹ ਬਣਾਉਣ ਦੇ ਖਰਚੇ',
        gethomedelivery: 'ਹੋਮ ਡਿਲਿਵਰੀ ਲਵੋ',
        constructionfee: 'ਨਿਰਮਾਣ ਫੀਸ',
        freeshipping: 'ਮੁਫਤ ਸ਼ਿਪਿੰਗ',
        address_delivery: 'ਤੁਹਾਡੀ ਪਤਾ ਸਪੁਰਦਗੀ',
        available_purchasebalance: 'ਤੁਹਾਡਾ ਸੋਨਾ ਬਕਾਇਆ ਖਰੀਦ ਬਕਾਏ ਤੋਂ ਘੱਟ ਹੈ. ਕਿਰਪਾ ਕਰਕੇ ਪਹਿਲਾਂ ਸੋਨਾ ਖਰੀਦੋ.',
        product_details: 'ਉਤਪਾਦ ਵੇਰਵਾ',
        add_newaddress: 'ਨਵਾਂ ਪਤਾ ਸ਼ਾਮਲ ਕਰੋ',
        specify_deliveryaddress: 'ਸਪੁਰਦਗੀ ਦਾ ਪਤਾ ਦੱਸੋ',
        fullname: 'ਪੂਰਾ ਨਾਮ',
        pincode: 'ਜ਼ਿਪ ਕੋਡ',
        house_no: 'ਮਕਾਨ ਨੰਬਰ',
        mobile_no: 'ਮੋਬਾਈਲ ਨੰਬਰ',
        digit_mobile_no: '10 ਅੰਕ ਮੋਬਾਈਲ ਨੰਬਰ ',
        landmark: 'ਲੈਂਡਮਾਰਕ',
        landmark_location: 'ਨੇੜਲੇ / ਮਸ਼ਹੂਰ ਟਿਕਾਣੇ',
        save_address: 'ਪਤਾ ਸੰਭਾਲੋ',
        gold_balance: 'ਸੋਨਾ ਸੰਤੁਲਨ',
        return_policy: 'ਵਾਪਸੀ ਨੀਤੀ',
        fill_fullname: 'ਪੂਰਾ ਨਾਮ ਭਰੋ ਜੀ',
        fill_state: 'ਕਿਰਪਾ ਕਰਕੇ ਰਾਜ ਵਿੱਚ ਬੱਚੇ',
        fill_houseno: 'ਕਿਰਪਾ ਕਰਕੇ ਸਹੀ ਮਕਾਨ ਨੰਬਰ ਭਰੋ',
        fill_mobileno: 'ਕਿਰਪਾ ਕਰਕੇ ਸਹੀ ਮੋਬਾਈਲ ਨੰਬਰ ਭਰੋ',
        fill_street: 'ਕਿਰਪਾ ਕਰਕੇ ਸਹੀ ਗਲੀ ਭਰੋ',
        fill_landmark: 'ਕਿਰਪਾ ਕਰਕੇ ਸਹੀ ਨਿਸ਼ਾਨ ਭਰੋ',
        product: 'ਉਤਪਾਦ',
        new_address: '+ ਨਵਾਂ ਪਤਾ ਸ਼ਾਮਲ ਕਰੋ',
        return_policydescription: 'ਵਾਪਸੀ / ਤਬਦੀਲੀ ਦੀ ਆਗਿਆ ਨਹੀਂ - ਇਸ ਉਤਪਾਦ ਲਈ ਵਿਕਰੇਤਾ ਦੁਆਰਾ ਵਾਪਸੀ ਜਾਂ ਤਬਦੀਲੀਆਂ ਸਵੀਕਾਰ ਨਹੀਂ ਕੀਤੀਆਂ ਜਾਂਦੀਆਂ ਰੱਦ ਕਰਨ ਦੀ ਆਗਿਆ ਨਹੀਂ - ਇਕ ਵਾਰ ਆਦੇਸ਼ ਦਿੱਤੇ ਜਾਣ ਤੇ ਇਸ ਉਤਪਾਦ ਲਈ ਰੱਦ ਕਰਨ ਦੀ ਆਗਿਆ ਨਹੀਂ ਹੈ.',
        product_descrp1: 'ਕਿਰਪਾ ਕਰਕੇ ਸਿਰਫ ਇਸ ਉਤਪਾਦ ਦੀ ਚੋਣ ਕਰੋ ਜੇ ਤੁਹਾਡੇ ਕੋਲ ਕਾਫ਼ੀ ਡਿਜੀਟਲ ਸੋਨੇ ਦਾ ਸੰਤੁਲਨ ਹੈ. ਨਾਕਾਫ਼ੀ ਸੋਨੇ ਦੀ ਰਕਮ ਦੇ ਮਾਮਲੇ ਵਿਚ, ਇਸ ਆਰਡਰ ਨੂੰ ਰੱਦ ਕਰ ਦਿੱਤਾ ਜਾਵੇਗਾ',
        product_descrp2: 'ਹਰੇਕ ਸਿੱਕੇ ਨੂੰ ਇੱਕ ਹਸਤਾਖਰ ਕੀਤੇ, ਗਿਣਤੀ ਵਾਲੇ ਸੁਰੱਖਿਆ ਸਰਟੀਫਿਕੇਟ ਪੈਕੇਜਿੰਗ ਵਿੱਚ ਸੀਲ ਕੀਤਾ ਜਾਂਦਾ ਹੈ ਜੋ ਧਾਤ ਦੀ ਸਮਗਰੀ, ਭਾਰ ਅਤੇ ਗੁਣਵਤਾ ਦੀ ਗਰੰਟੀ ਦਿੰਦਾ ਹੈ.',
        product_descrp3: 'ਇਹ ਸਿੱਕਾ ਇਕ ਆਧੁਨਿਕ, ਰਾਜ ਦੀ ਆਧੁਨਿਕ ਰਿਫਾਇਨਰੀ ਵਿਚ ਉੱਚ ਸਵਿੱਸ ਇੰਜੀਨੀਅਰਿੰਗ ਦੇ ਹੁਨਰ ਦੀ ਵਰਤੋਂ ਕਰਦਿਆਂ ਬਣਾਇਆ ਗਿਆ ਹੈ. ਸੇਫ-ਗੋਲਡ ਭਾਰਤ ਦੀ ਇਕਲੌਤੀ ਰਿਫਾਇਨਰੀ ਹੈ ਜੋ ਐਲ ਬੀ ਐਮ ਏ (ਲੰਡਨ ਬੁਲੀਅਨ ਮਾਰਕੀਟ ਐਸੋਸੀਏਸ਼ਨ) ਦੁਆਰਾ ਪ੍ਰਵਾਨਿਤ ਹੈ, ਸੋਨੇ ਅਤੇ ਚਾਂਦੀ ਦਾ ਵਿਸ਼ਵ ਪੱਧਰ.',
        product_descrp4: 'ਉਸ ਦਿਨ ਬਿੱਲ ਦੇ ਉਤਪਾਦਨ ਤੇ 100% ਸੋਨੇ ਦੀ ਕੀਮਤ ਤੇ ਸੇਫ-ਗੋਲਡ ਸਟੋਰ ਵਿਚ ਸੌਖੀ ਖਰੀਦਦਾਰ ਖਰੀਦ.',
        delivery_date: 'ਡਿਲੀਵਰੀ ਦੀ ਮਿਤੀ',
        refundpaytm: 'paytm ਵਿੱਚ ਰਿਫੰਡ',
        goldproduct: 'ਸੋਨੇ ਦਾ ਉਤਪਾਦ',
        gift_lockerbalance: 'ਤੁਹਾਡਾ ਲਾਕਰ ਬੈਲੇਂਸ',
        giftyourself: 'ਆਪਣੇ ਆਪ ਨੂੰ ਦਾਤ',
        mobilenumber: 'ਮੋਬਾਈਲ ਨੰਬਰ',
        enteramountgold: 'ਰੁਪਏ ਵਿਚ ਮਾਤਰਾ ਸੋਨਾ ਦਰਜ ਕਰੋ.',
        message: 'ਸੁਨੇਹਾ',
        gold_gifthere: 'ਇਹ ਤੁਹਾਡਾ ਸੋਨਾ ਤੋਹਫਾ ਹੈ',
        goldgift: 'ਤੋਹਫਾ ਸੋਨਾ',
        gifthistory: 'ਉਪਹਾਰ ਦਾ ਇਤਿਹਾਸ',
        myorders: 'ਮੇਰੇ ਆਦੇਸ਼',
        note: 'ਨੋਟ',
        transactionid: 'ਟ੍ਰਾਂਜੈਕਸ਼ਨ ਆਈਡੀ',
        invoiceid: 'ਇਨਵੌਇਸ ਆਈਡੀ',
        sinceamountlessthan: 'ਕਿਉਂਕਿ, ਤੁਹਾਡੀ ਰਕਮ 50 ਤੋਂ ਘੱਟ ਹੈ',
        amountshow: 'ਇਸ ਲਈ ਰਕਮ',
        transferredpaytmwallet: 'ਨੂੰ ਤੁਹਾਡੇ ਪੇਟੀਐਮ ਵਾਲਿਟ ਵਿਚ ਤਬਦੀਲ ਕਰ ਦਿੱਤਾ ਜਾਵੇਗਾ',
        gift: 'ਦਾਤ',
        entervalid_mobileno: 'ਇੱਕ ਵੈਧ ਮੋਬਾਈਲ ਨੰਬਰ ਦਾਖਲ ਕਰੋ',
        enter_goldamount: 'ਸੋਨੇ ਦੀ ਮਾਤਰਾ ਦਾਖਲ ਕਰੋ',
        enough_gold: 'ਤੁਹਾਡੇ ਕੋਲ ਇੰਨਾ ਸੋਨਾ ਨਹੀਂ ਹੈ',
        successfully_giftedgold: 'ਤੁਸੀਂ ਸਫਲਤਾ ਨਾਲ ਸੋਨਾ ਤੋਹਫਾ ਕੀਤਾ ਹੈ',
        no_history: 'ਕੋਈ ਇਤਿਹਾਸ ਉਪਲਬਧ ਨਹੀਂ',
        trackorder: 'ਟਰੈਕ ਆਰਡਰ',
        deliveryestimate: 'ਡਿਲਿਵਰੀ ਦਾ ਅੰਦਾਜ਼ਾ:',
        order_id: 'ਆਰਡਰ ਆਈਡੀ',
        receiver_notregister: 'ਪ੍ਰਾਪਤ ਕਰਨ ਵਾਲਾ ਰਜਿਸਟਰਡ ਨਹੀਂ ਹੈ'
    }
};

const i18n = new VueI18n({
    locale: "hi", // set locale
    fallbackLocale: "hi", // set fallback locale
    messages // set locale messages
});

export default i18n;